import type { Locale, TranslationKey } from "./types";

export const DEFAULT_LOCALE: Locale = "zh-CN";

export const LOCALE_LABELS: Record<Locale, string> = {
  en: "English",
  "zh-CN": "简体中文",
  "zh-TW": "繁體中文",
};

const en: Record<TranslationKey, string> = {
  "app_error.403.text": "Access to this resource is restricted.",
  "app_error.403.title": "Alert",
  "app_error.404.text":
    "This page is no longer explorable. Use the search bar to find what you are looking for.",
  "app_error.404.title": "Page not found",
  "app_error.422.text":
    "Your request contained an error, perhaps a mistyped tx/block/address hash. " +
    "Try again, and check the developer tools console for more info.",
  "app_error.422.title": "Request cannot be processed",
  "app_error.500.text":
    "An unexpected error has occurred. Try reloading the page, or come back soon and try again.",
  "app_error.500.title": "Oops! Something went wrong",
  "common.age": "Age",
  "common.add_address": "Add address",
  "common.add_api_key": "Add API key",
  "common.add_token_to_wallet": "Add token to {wallet}",
  "common.apple": "Apple",
  "common.all": "All",
  "common.address": "Address",
  "common.api_documentation_unavailable": "No API documentation available",
  "common.back_to_home": "Back to home",
  "common.balance": "Balance",
  "common.balance_with_symbol": "Balance {symbol}",
  "common.base_fee": "Base fee",
  "common.block": "Block",
  "common.block_confirmations": "{count} Block confirmations",
  "common.burnt_fees": "Burnt fees",
  "common.bytes": "bytes",
  "common.call": "Call",
  "common.batch": "Batch",
  "common.category": "Category",
  "common.constructor_args": "Constructor args",
  "common.contract": "Contract",
  "common.contract_address": "Contract address",
  "common.copy": "copy",
  "common.copy_link_to_clipboard": "Copy link to clipboard",
  "common.copy_to_clipboard": "Copy to clipboard",
  "common.copied": "Copied",
  "common.current_block": "Current block",
  "common.default": "Default",
  "common.details": "Details",
  "common.documentation": "Documentation",
  "common.error.try_refresh":
    "Something went wrong. Try refreshing the page or come back later.",
  "common.estimated_target_date": "Estimated target date",
  "common.fast": "Fast",
  "common.fee": "Fee",
  "common.filter": "Filter",
  "common.first": "First",
  "common.from": "From",
  "common.from_to": "From/To",
  "common.gas_used": "Gas used",
  "common.google": "Google",
  "common.hide": "Hide",
  "common.hide_details": "Hide details",
  "common.hide_scam_tokens": "Hide scam tokens",
  "common.history": "History",
  "common.how_to_use_blockscout_api_key": "How to use a Blockscout API key",
  "common.hex": "Hex",
  "common.info": "Info",
  "common.inventory": "Inventory",
  "common.l1_txn": "L1 txn",
  "common.l1_txn_hash": "L1 txn hash",
  "common.l2_txn": "L2 txn",
  "common.l2_txn_hash": "L2 txn hash",
  "common.l2_block_no": "L2 block No",
  "common.language": "Language",
  "common.language_compiler_version": "Language / Compiler version",
  "common.last_update": "Last update",
  "common.left": "left",
  "common.links": "Links",
  "common.load_high": "high load",
  "common.load_low": "low load",
  "common.load_medium": "medium load",
  "common.license": "License",
  "common.logs": "Logs",
  "common.lookup_related_domains": "Lookup for related domain names",
  "common.loading": "Loading data, please wait...",
  "common.need_help_contact_admin": "Need help? Contact admin team at ",
  "common.normal": "Normal",
  "common.no_data": "No data. Please reload the page.",
  "common.no_data_selected_interval":
    "No data for the selected resolution and interval.",
  "common.no_data_short": "No data",
  "common.no_blocks": "There are no blocks.",
  "common.no_results": "No results",
  "common.no_results_found": "No results found.",
  "common.no_transactions": "There are no transactions.",
  "common.holder": "Holder",
  "common.holders": "Holders",
  "common.id_short": "ID#",
  "common.index": "Index",
  "common.on_chain_market_cap": "On-chain market cap",
  "common.owner": "Owner",
  "common.optimization": "Optimization",
  "common.parent_txn_hash": "Parent txn hash",
  "common.per_transaction": "per transaction",
  "common.percentage": "Percentage",
  "common.pending_claim": "Pending Claim",
  "common.prev_page": "Prev page",
  "common.next_page": "Next page",
  "common.price": "Price",
  "common.priority": "Priority",
  "common.quantity": "Quantity",
  "common.rank": "Rank",
  "common.raw": "Raw",
  "common.remaining_blocks": "Remaining blocks",
  "common.reset": "Reset",
  "common.reset_zoom": "Reset zoom",
  "common.reward": "Reward",
  "common.sender": "Sender",
  "common.select_chain": "Select chain",
  "common.select_interval": "Select interval",
  "common.select_type": "Select type",
  "common.settings": "Settings",
  "common.size": "Size",
  "common.size_bytes": "Size, bytes",
  "common.slow": "Slow",
  "common.show_info": "Show info",
  "common.status": "Status",
  "common.success": "Success",
  "common.failed": "Failed",
  "common.pending": "Pending",
  "common.timestamp": "Timestamp",
  "common.time_left": "Time left",
  "common.this_tool": "this tool",
  "common.to": "To",
  "common.testnet_transaction_only": "This is a testnet transaction only",
  "common.toggle_time_format": "Toggle time format",
  "common.total_contracts": "Total contracts",
  "common.transfers": "Transfers",
  "common.txn": "Txn",
  "common.txn_count": "Txn count",
  "common.txn_hash": "Txn hash",
  "common.tx_hash": "Tx hash",
  "common.txs": "Txs",
  "common.type": "Type",
  "common.utf8": "UTF-8",
  "common.method": "Method",
  "common.method_id": "Method id",
  "common.msg_nonce": "Msg nonce",
  "common.name": "Name",
  "common.token": "Token",
  "common.token_id": "Token ID",
  "common.user_op_hash": "User op hash",
  "common.user": "User",
  "common.validator_index": "Validator index",
  "common.value": "Value",
  "common.view_all": "View all",
  "common.view_details": "View details",
  "common.view_all_results": "View all results",
  "common.verified": "Verified",
  "common.verified_contracts": "Verified contracts",
  "common.verify_with": "Verify with",
  "common.verify_with_other_explorers": "Verify with other explorers",
  "common.website_settings": "Website settings",
  "common.widgets": "Widgets",
  "common.zk_compiler": "ZK compiler",
  "common.for_assistance": " for assistance!",
  "common.account_history": "Account history",
  "common.address_from": "Address from",
  "common.address_to": "Address to",
  "common.amount": "Amount",
  "common.amount_from": "Amount from",
  "common.amount_to": "Amount to",
  "common.and_or": "And/Or",
  "common.api_documentation": "API documentation",
  "common.asset": "Asset",
  "common.asset_flows": "Asset Flows",
  "common.authorizations": "Authorizations",
  "common.base": "Base",
  "common.blob_fee": "Blob fee",
  "common.blob_gas_fees": "Blob gas fees",
  "common.blob_gas_usage": "Blob gas usage",
  "common.blobs": "Blobs",
  "common.code": "Code",
  "common.coin_transfer": "Coin Transfer",
  "common.coin_balance_history": "Coin balance history",
  "common.columns": "Columns",
  "common.commitment_tx": "Commitment tx",
  "common.confirmation_status": "Confirmation status",
  "common.confirmation_tx": "Confirmation tx",
  "common.contract_creation": "Contract creation",
  "common.confirmed_within": "Confirmed within {lower} secs",
  "common.confirmed_within_lte": "Confirmed within <= {upper} secs",
  "common.confirmed_within_range": "Confirmed within {lower} - {upper} secs",
  "common.date_from": "Date from",
  "common.date_to": "Date to",
  "common.data": "Data",
  "common.decimals": "Decimals",
  "common.decoded_input_data": "Decoded input data",
  "common.dapp": "Dapp",
  "common.epoch_rewards": "Epoch rewards",
  "common.eth_rpc_api": "ETH RPC API",
  "common.exclude": "Exclude",
  "common.find_by_function_name_method_id": "Find by function name/ method ID",
  "common.finalized": "Finalized",
  "common.gas_fees": "Gas fees",
  "common.gas_limit": "Gas limit",
  "common.gas_price": "Gas price",
  "common.gas_used_for_l1": "Gas used for L1",
  "common.gas_used_for_l2": "Gas used for L2",
  "common.gas_usage_and_limit_by_txn": "Gas usage & limit by txn",
  "common.graphql_api": "GraphQL API",
  "common.include": "Include",
  "common.indexed": "Indexed?",
  "common.incoming_message": "Incoming message",
  "common.interacted_with_contract": "Interacted with contract",
  "common.internal_txns": "Internal txns",
  "common.interop_target": "Interop target",
  "common.kettle": "Kettle",
  "common.l1_fee": "L1 fee",
  "common.l1_fee_scalar": "L1 fee scalar",
  "common.l1_gas_price": "L1 gas price",
  "common.l1_gas_used": "L1 Gas used",
  "common.l1_gas_used_by_txn": "L1 gas used by txn",
  "common.l1_status": "L1 status",
  "common.l2_status_and_method": "L2 status and method",
  "common.market_cap": "Market cap",
  "common.max": "Max",
  "common.max_priority": "Max priority",
  "common.max_total_supply": "Max total supply",
  "common.metadata": "Metadata",
  "common.network_fee": "Network fee",
  "common.no_tokens_found": "No tokens found",
  "common.nonce": "Nonce",
  "common.outgoing_message": "Outgoing message",
  "common.popular": "Popular",
  "common.poster_fee": "Poster fee",
  "common.raw_input": "Raw input",
  "common.raw_trace": "Raw trace",
  "common.revert_reason": "Revert reason",
  "common.rest_api": "REST API",
  "common.rpc_api_endpoints": "RPC API endpoints",
  "common.select_mode": "Select mode",
  "common.sequence_tx_hash": "Sequence tx hash",
  "common.smart_contract_or_address": "Smart contract / Address (0x...)*",
  "common.show_all": "Show all",
  "common.syncing_with_base_layer": "Syncing with base layer",
  "common.state": "State",
  "common.status_and_method": "Status and method",
  "common.validated_by": "Validated by",
  "common.contract_execution_completed": "Contract execution completed",
  "common.contract_execution_error": "Error occurred during contract execution",
  "common.contract_execution_status": "Contract execution status",
  "common.could_not_determine": "Could not determine",
  "common.execution_fee": "Execution fee",
  "common.blocks_mined": "Blocks mined",
  "common.blocks_posted": "Blocks posted",
  "common.blocks_sequenced": "Blocks sequenced",
  "common.blocks_validated": "Blocks validated",
  "common.interop_relay_tx": "Interop relay tx",
  "common.interop_source_tx": "Interop source tx",
  "common.interop_status": "Interop status",
  "common.l1_commit_scalar": "L1 commit scalar",
  "common.l1_block_height": "L1 block height",
  "common.l1_blob_fees": "L1 blob fees",
  "common.l1_data_fee": "L1 data fee",
  "common.l1_fee_overhead": "L1 fee overhead",
  "common.l1_gas_fees": "L1 gas fees",
  "common.message_id": "Message id",
  "common.mined_by": "Mined by",
  "common.other": "Other",
  "common.payload": "Payload",
  "common.position": "Position",
  "common.posted_by": "Posted by",
  "common.queue_index": "Queue index",
  "common.ready_for_relay": "Ready for relay",
  "common.relayed": "Relayed",
  "common.reorged_block": "Reorged block",
  "common.scalar": "Scalar",
  "common.sequenced_by": "Sequenced by",
  "common.settlement_pending": "Settlement pending",
  "common.target": "Target",
  "common.tokens_burnt": "Tokens burnt",
  "common.tokens_created": "Tokens created",
  "common.tokens_minted": "Tokens minted",
  "common.tokens_transferred": "Tokens transferred",
  "common.transaction_details": "Transaction details",
  "common.transaction_fee": "Transaction fee",
  "common.transaction_hash": "Transaction hash",
  "common.transactions": "Transactions",
  "common.txn_batch": "Txn batch",
  "common.block_height": "Block height",
  "common.uncle_block": "Uncle block",
  "common.type_of_transfer": "Type of transfer",
  "common.user_operations": "User operations",
  "common.verify_tx_hash": "Verify tx hash",
  "common.view_next_block": "View next block",
  "common.view_previous_block": "View previous block",
  "common.waiting": "Waiting",
  "common.waiting_for_confirmation": "Waiting for confirmation",
  "common.withdrawal_status": "Withdrawal status",
  "home.average_block_time": "Average block time",
  "home.blockchain_explorer": "{network} blockchain explorer",
  "home.btc_locked_in_2wp": "BTC Locked in 2WP",
  "home.current_epoch": "Current epoch",
  "home.daily_operational_txs": "Daily op txns",
  "home.daily_operational_txs_hint":
    "Number of operational transactions yesterday (0:00 - 23:59 UTC). " +
    "The chart displays daily operational transactions for the past 30 days.",
  "home.daily_txs": "Daily transactions",
  "home.daily_txs_hint":
    "Number of transactions yesterday (0:00 - 23:59 UTC). The chart displays daily transactions for the past 30 days.",
  "home.deposits_l1_l2_txn": "Deposits (L1→L2 txn)",
  "home.explorer": "{network} explorer",
  "home.finalized_epoch": "Finalized epoch #{epoch}",
  "home.latest_batch": "Latest batch",
  "home.latest_batches": "Latest batches",
  "home.latest_blocks": "Latest blocks",
  "home.latest_l1_state_batch": "Latest L1 state batch",
  "home.latest_transactions": "Latest transactions",
  "home.latest_txn": "Latest txn",
  "home.market_cap": "Market cap",
  "home.market_cap_hint":
    "The total market value of a cryptocurrency circulating supply. Market Cap = Current Price x Circulating Supply.",
  "home.network_utilization": "Network utilization",
  "home.token_price": "{symbol} price",
  "home.token_price_hint": "{symbol} token daily price in USD.",
  "home.total_blocks": "Total blocks",
  "home.total_operational_transactions": "Total operational transactions",
  "home.total_transactions": "Total transactions",
  "home.transactions": "Transactions",
  "transactions.avg_transaction_fee": "Avg. transaction fee",
  "transactions.pending_transactions": "Pending transactions",
  "transactions.transaction_fees": "Transaction fees",
  "tokens.all": "All",
  "tokens.bridged": "Bridged",
  "tokens.bridged_description":
    "List of the tokens bridged through {bridges} extensions",
  "tokens.crypto_markets": "Crypto markets",
  "tokens.description_support_info": "Description and support info",
  "tokens.empty_filtered":
    "Could not find a token that matches your filter query.",
  "tokens.filtered_by_owner": "Filtered by owner",
  "tokens.owner_hint": "Current owner of this token instance",
  "tokens.creator": "Creator",
  "tokens.creator_hint": "Address that deployed this token contract",
  "tokens.token_id_hint": "This token instance unique token ID",
  "tokens.transfers_hint": "Number of transfer for the token instance",
  "tokens.dapp_hint": "Link to the dapp",
  "tokens.metadata.error_title": "Error",
  "tokens.metadata.refresh_failed": "The refreshing process has failed. Please try again.",
  "tokens.metadata.please_wait": "Please wait",
  "tokens.metadata.refetch_request_sent": "Refetching metadata request sent",
  "tokens.metadata.unable_to_initialize": "Unable to initialize metadata update",
  "tokens.metadata.success_title": "Success!",
  "tokens.metadata.refreshed": "Metadata has been refreshed",
  "tokens.metadata.sending_request": "Sending request",
  "tokens.metadata.recaptcha_missing":
    "Metadata refresh is not available at the moment since reCaptcha is not configured for this application. " +
    "Please contact the service maintainer to make necessary changes in the service configuration.",
  "tokens.metadata.refresh": "Refresh metadata",
  "tokens.metadata.no_metadata": "There is no metadata for this NFT",
  "tokens.metadata.refresh_error_title": "Ooops!",
  "tokens.metadata.refresh_error_desc": "We couldn't refresh metadata. Please try again now or later.",
  "tokens.metadata.table": "Table",
  "tokens.no_holders": "There are no holders for this token.",
  "tokens.no_owner_tokens": "No tokens found for the selected owner.",
  "tokens.no_tokens": "There are no tokens.",
  "tokens.placeholder": "Token name or symbol",
  "tokens.title": "Tokens",
  "tokens.title_with_network": "Tokens on {network}",
  "token_transfers.address_filter": "Address",
  "token_transfers.incoming": "Incoming transfers",
  "token_transfers.no_token_transfers": "There are no token transfers.",
  "token_transfers.outgoing": "Outgoing transfers",
  "token_transfers.title": "Token transfers",
  "token_transfer.type.token_minting": "Token minting",
  "token_transfer.type.token_burning": "Token burning",
  "token_transfer.type.token_spawning": "Token creating",
  "token_transfer.type.token_transfer": "Token transfer",
  "home.tvl": "Total value locked",
  "home.tvl_hint": "Total value of digital assets locked or staked in a chain.",
  "home.tx_per_day": "Tx/day",
  "home.view_all_batches": "View all batches",
  "home.view_all_blocks": "View all blocks",
  "home.view_all_deposits": "View all deposits",
  "home.view_all_transactions": "View all transactions",
  "home.view_all_watch_list_transactions": "View all watch list transactions",
  "home.wallet_addresses": "Wallet addresses",
  "language.english": "English",
  "language.label": "Language",
  "language.simplified_chinese": "简体中文",
  "language.traditional_chinese": "繁體中文",
  "nav.api": "API",
  "nav.api_keys": "API keys",
  "nav.advanced_filter": "Advanced filter",
  "nav.blocks": "Blocks",
  "nav.blockchain": "Blockchain",
  "nav.charts_stats": "Charts & stats",
  "nav.brand_name_zh": "保全链",
  "nav.brand_name_en": "VeraXChain",
  "nav.custom_abi": "Custom ABI",
  "nav.dapps": "DApps",
  "nav.deposits_l1_l2": "Deposits (L1→L2)",
  "nav.dex_tracker": "DEX tracker",
  "nav.dispute_games": "Dispute games",
  "nav.epochs": "Epochs",
  "nav.gas_tracker": "Gas tracker",
  "nav.internal_transactions": "Internal transactions",
  "nav.interop_messages": "Interop messages",
  "nav.mud_worlds": "MUD worlds",
  "nav.name_services_lookup": "Name services lookup",
  "nav.operations": "Operations",
  "nav.other": "Other",
  "nav.output_roots": "Output roots",
  "nav.private_tags": "Private tags",
  "nav.submit_public_tag": "Submit public tag",
  "nav.token_transfers": "Token transfers",
  "nav.tokens": "Tokens",
  "nav.top_accounts": "Top accounts",
  "nav.transactions": "Transactions",
  "nav.txn_batches": "Txn batches",
  "nav.txn_withdrawals": "Txn withdrawals",
  "nav.user_operations": "User operations",
  "nav.validators": "Validators",
  "nav.verified_addrs": "Verified addrs",
  "nav.verified_contracts": "Verified contracts",
  "nav.verify_contract": "Verify contract",
  "nav.watch_list": "Watch list",
  "nav.withdrawals": "Withdrawals",
  "nav.withdrawals_l2_l1": "Withdrawals (L2→L1)",
  "accounts.no_accounts": "There are no accounts.",
  "network.chains_list": "Chains list",
  "network.menu": "Network menu",
  "network.mainnets": "Mainnets",
  "network_role.miner": "Miner",
  "network_role.poster": "Poster",
  "network_role.sequencer": "Sequencer",
  "network_role.validator": "Validator",
  "network.other": "Other",
  "network.testnets": "Testnets",
  "network_validation.mined": "Mined",
  "network_validation.posted": "Posted",
  "network_validation.sequenced": "Sequenced",
  "network_validation.validated": "Validated",
  "page.block_countdown": "Block countdown",
  "page.block_countdown.description":
    "The estimated time for a block to be created and added to the blockchain.",
  "page.block_countdown.placeholder": "Search by block number",
  "page.blob.details": "Blob details",
  "page.blocks.all": "All",
  "page.blocks.forked": "Forked",
  "page.blocks.uncles": "Uncles",
  "page.advanced_filter.filtered_by": "Filtered by:",
  "page.advanced_filter.no_match": "No match found for current filter",
  "page.advanced_filter.reset_filters": "Reset filters",
  "page.api_keys.description":
    "Create API keys to use for your RPC and EthRPC API requests. For more information, see ",
  "page.api_keys.limit_notice":
    "You have added the maximum number of API keys ({limit}). Contact us to request additional keys.",
  "page.api_docs.blockscout_core_api": "Blockscout core API",
  "page.api_docs.eth_rpc_api_description":
    "In addition to the custom RPC endpoints documented here, " +
    "the Blockscout ETH RPC API supports 3 methods in the exact format specified for Ethereum nodes. " +
    "See the Ethereum JSON-RPC Specification for more details.",
  "page.api_docs.name_service_api": "Name service API",
  "page.api_docs.rpc_api_description":
    "This API is provided for developers transitioning applications from Etherscan to Blockscout " +
    "and applications requiring general API and data support. It supports GET and POST requests.",
  "page.api_docs.stats_api": "Stats API",
  "page.api_docs.tac_operation_lifecycle_api": "TAC operation lifecycle API",
  "page.api_docs.title": "API documentation",
  "page.api_docs.title_with_network": "{network} API documentation",
  "page.api_docs.user_ops_indexer_api": "User ops indexer API",
  "page.api_docs.swagger.try_it_out": "Try it out",
  "page.api_docs.swagger.cancel": "Cancel",
  "page.api_docs.swagger.execute": "Execute",
  "page.api_docs.swagger.clear": "Clear",
  "page.api_docs.swagger.parameters": "Parameters",
  "page.api_docs.swagger.responses": "Responses",
  "page.api_docs.swagger.description": "Description",
  "page.api_docs.swagger.name": "Name",
  "page.api_docs.swagger.links": "Links",
  "page.api_docs.swagger.code": "Code",
  "page.api_docs.swagger.schema": "Schema",
  "page.api_docs.swagger.example_value": "Example Value",
  "page.api_docs.swagger.media_type": "Media type",
  "page.api_docs.swagger.no_links": "No links",
  "page.api_docs.swagger.request_body": "Request body",
  "page.api_docs.swagger.response_headers": "Response headers",
  "page.api_docs.swagger.response_body": "Response body",
  "page.api_docs.swagger.loading": "Loading",
  "page.api_docs.swagger.models": "Models",
  "page.api_docs.swagger.schemas": "Schemas",
  "page.api_docs.swagger.model": "Model",
  "page.api_docs.swagger.show": "Show",
  "page.api_docs.swagger.hide": "Hide",
  "page.api_docs.swagger.required": "Required",
  "page.api_docs.swagger.available_values": "Available values",
  "page.api_docs.swagger.response_content_type": "Response content type",
  "page.api_docs.swagger.parameter_content_type": "Parameter content type",
  "page.api_docs.swagger.apply": "Apply",
  "page.api_docs.swagger.close": "Close",
  "page.api_docs.swagger.download": "Download",
  "page.api_docs.swagger.servers": "Servers",
  "page.api_docs.swagger.authorize": "Authorize",
  "page.api_docs.swagger.copy": "Copy",
  "page.api_docs.swagger.unable_to_render": "Unable to render",
  "page.api_docs.swagger.examples": "Examples",
  "page.api_docs.swagger.request_url": "Request URL",
  "page.api_docs.swagger.server_response": "Server response",
  "page.api_docs.swagger.curl": "Curl",
  "page.api_docs.swagger.request_duration": "Request duration",
  "page.api_docs.swagger.edit_value": "Edit Value",
  "page.address.contract_details": "Contract details",
  "page.address.contract_details_on": "Contract details on {network}",
  "page.address.details": "Address details",
  "page.address.details_on": "Address details on {network}",
  "page.address.checking_contract_verification": "Checking contract verification",
  "page.address.contract_successfully_verified": "Contract successfully verified",
  "page.address.contract_not_verified_automatically": "Contract not verified automatically. Please verify manually.",
  "page.address.contract_creation_code": "Contract creation code",
  "page.address.contract_selfdestructed_after_deployment":
    "This contract self-destructed after deployment and there is no runtime bytecode. Below is the raw creation bytecode.",
  "page.address.contract_creation_failed":
    "Contract creation failed and there is no runtime bytecode. Below is the raw creation bytecode.",
  "page.address.verify_and_publish": "Verify & publish",
  "page.address.deployed_bytecode": "Deployed bytecode",
  "page.address.click_to_view_qr": "Click to view QR code",
  "page.address.show_qr": "Show QR code",
  "page.address.unable_to_generate_qr": "We were unable to generate QR code.",
  "page.address.address_qr_code": "Address QR code",
  "page.address.token_label": "Token",
  "page.address.token_name": "Token name",
  "page.address.token_name_hint": "Token name and symbol",
  "page.address.contract_name": "Contract name",
  "page.address.contract_name_hint": "The name found in the source code of the Contract",
  "page.address.validator_name": "Validator name",
  "page.address.validator_name_hint": "The name of the validator",
  "page.address.creator": "Creator",
  "page.address.creator_hint": "Transaction and address of creation",
  "page.address.balance": "Balance",
  "page.address.balance_hint": "{unit} balance",
  "page.address.tokens": "Tokens",
  "page.address.tokens_hint": "All tokens in the account and total value",
  "page.address.net_worth": "Net worth",
  "page.address.net_worth_hint": "Total net worth in USD of all tokens for the address",
  "page.address.transactions": "Transactions",
  "page.address.transactions_hint": "Number of transactions related to this address",
  "page.address.transfers": "Transfers",
  "page.address.transfers_hint": "Number of transfers to/from this address",
  "page.address.gas_used": "Gas used",
  "page.address.gas_used_hint": "Gas used by the address",
  "page.address.last_balance_update": "Last balance update",
  "page.address.last_balance_update_hint": "Block number in which the address was updated",
  "page.address.widgets_hint": "Metrics provided by third party partners",
  "page.address.at_txn": "at txn",
  "page.address.filecoin_id": "ID",
  "page.address.filecoin_id_hint": "Short identifier of an address that may change with chain state updates",
  "page.address.filecoin_actor": "Actor",
  "page.address.filecoin_actor_hint": "Identifies the purpose and behavior of the address on the Filecoin network",
  "page.address.filecoin_eth_address": "Ethereum Address",
  "page.address.filecoin_eth_address_hint": "0x-style address to which the Filecoin address is assigned by the Ethereum Address Manager",
  "page.address.outgoing_transactions": "Outgoing transactions",
  "page.address.incoming_transactions": "Incoming transactions",
  "page.address.no_internal_txs": "There are no internal transactions for this address.",
  "page.address.no_logs": "There are no logs for this address.",
  "page.address.no_coin_balance_history": "There is no coin balance history for this address.",
  "page.address.no_tokens_of_type": "There are no tokens of selected type.",
  "page.address.empty_filtered_transactions": "Couldn't find any transaction that matches your query.",
  "page.address.empty_filtered_token_transfers": "Couldn't find any token transfer that matches your query.",
  "page.address.by_collection": "By collection",
  "page.address.list": "List",
  "page.address.nfts": "NFTs",
  "page.address.view_in_collection": "View in collection",
  "page.address.view_all_nfts": "View all NFTs",
  "page.address.items_count": "{count} item{plural}",
  "page.address.tokens_count": "{count} token{plural}",
  "page.address.delta": "Delta",
  "page.address.balances": "Balances",
  "page.address.insufficient_chart_data": "Insufficient data for the past {days} days",

  "page.contract_verification.new_title": "New smart contract verification",
  "page.contract_verification.title": "Verify & publish contract",

  "contract_verification.address_heading": "Contract address to verify",
  "contract_verification.address_placeholder": "Smart contract / Address (0x...)",
  "contract_verification.license_placeholder": "Contract license",
  "contract_verification.license_hint":
    "For best practices, all contract source code holders, publishers and authors are encouraged to also specify the accompanying license for their verified contract source code provided.",
  "contract_verification.method_heading": "Currently supports {count} contract verification methods",
  "contract_verification.method_heading_tooltip": "Currently supports {count} methods:",
  "contract_verification.method_placeholder": "Verification method (compiler type)",
  "contract_verification.verify_publish": "Verify & publish",
  "contract_verification.verify_publish_loading": "Verify & publish",
  "contract_verification.success_title": "Success",
  "contract_verification.success_description": "Contract is successfully verified.",
  "contract_verification.error_title": "Error",
  "contract_verification.socket_error": "There was an error with socket connection. Try again later.",
  "contract_verification.already_verified": "Contract has already been verified",
  "contract_verification.not_smart_contract": "Address is not a smart contract",
  "contract_verification.something_wrong": "Something went wrong",
  "contract_verification.method.flattened_code": "Solidity (Single file)",
  "contract_verification.method.standard_input": "Solidity (Standard JSON input)",
  "contract_verification.method.sourcify": "Solidity (Sourcify)",
  "contract_verification.method.multi_part": "Solidity (Multi-part files)",
  "contract_verification.method.vyper_code": "Vyper (Contract)",
  "contract_verification.method.vyper_multi_part": "Vyper (Multi-part files)",
  "contract_verification.method.vyper_standard_input": "Vyper (Standard JSON input)",
  "contract_verification.method.solidity_hardhat": "Solidity (Hardhat)",
  "contract_verification.method.solidity_foundry": "Solidity (Foundry)",
  "contract_verification.method.stylus_github": "Stylus (GitHub repository)",
  "contract_verification.method_hint.flattened_code": "Verification through a single file.",
  "contract_verification.method_hint.multi_part": "Verification of multi-part Solidity files.",
  "contract_verification.method_hint.sourcify": "Verification through Sourcify.",
  "contract_verification.method_hint.standard_input": "Verification using Standard input JSON file.",
  "contract_verification.method_hint.standard_input_link": "Standard input JSON",
  "contract_verification.method_hint.vyper_code": "Verification of Vyper contract.",
  "contract_verification.method_hint.vyper_multi_part": "Verification of multi-part Vyper files.",
  "contract_verification.method_hint.vyper_standard_input": "Verification of Vyper contract using Standard input JSON file.",
  "contract_verification.method_hint.vyper_standard_input_link": "Standard input JSON",
  "contract_verification.method_hint.solidity_hardhat": "Verification through Hardhat plugin.",
  "contract_verification.method_hint.solidity_foundry": "Verification through Foundry.",
  "contract_verification.method_hint.stylus_github": "Verification of Stylus contract via GitHub repository.",
  "contract_verification.title.flattened_code": "Contract verification via Solidity (flattened source code)",
  "contract_verification.title.standard_input": "Contract verification via Solidity (standard JSON input)",
  "contract_verification.title.sourcify": "Contract verification via Solidity (Sourcify)",
  "contract_verification.title.multi_part": "Contract verification via Solidity (multi-part files)",
  "contract_verification.title.vyper_code": "Contract verification via Vyper (contract)",
  "contract_verification.title.vyper_multi_part": "Contract verification via Vyper (multi-part files)",
  "contract_verification.title.vyper_standard_input": "Contract verification via Vyper (standard JSON input)",
  "contract_verification.title.solidity_hardhat": "Contract verification via Solidity Hardhat plugin",
  "contract_verification.title.solidity_foundry": "Contract verification via Foundry",
  "contract_verification.title.stylus_github": "Contract verification via Stylus (GitHub repository)",
  "contract_verification.field.contract_name": "Contract name",
  "contract_verification.field.contract_code": "Contract code",
  "contract_verification.field.compiler": "Compiler",
  "contract_verification.field.evm_version": "EVM Version",
  "contract_verification.field.constructor_args": "ABI-encoded Constructor Arguments",
  "contract_verification.field.optimization_runs": "Optimization runs",
  "contract_verification.field.library_name": "Library name (.sol file)",
  "contract_verification.field.library_item_title": "Contract library {index}",
  "contract_verification.hint.library_name": "A library name called in the .sol file. Multiple libraries (up to 10) may be added for each contract.",
  "contract_verification.hint.library_address": "The 0x library address. This can be found in the generated json file or Truffle output (if using truffle).",
  "contract_verification.field.library_address": "Library address (0x...)",
  "contract_verification.field.github_repo_url": "GitHub repository URL",
  "contract_verification.field.commit_hash": "Commit hash",
  "contract_verification.field.path_prefix": "Path prefix",
  "contract_verification.field.zk_compiler": "ZK compiler",
  "contract_verification.field.optimization_enabled": "Optimization enabled",
  "contract_verification.field.is_yul": "Is Yul contract",
  "contract_verification.field.autodetect_constructor_args": "Try to fetch constructor arguments automatically",
  "contract_verification.field.add_libraries": "Add contract libraries",
  "contract_verification.field.standard_input_json": "Standard Input JSON",
  "contract_verification.field.include_nightly": "Include nightly builds",
  "contract_verification.hint.compiler_solidity":
    "The compiler version is specified in pragma solidity X.X.X. Use the compiler version rather than the nightly build. If using the Solidity compiler, run solc —version to check.",
  "contract_verification.hint.constructor_args":
    "Add arguments in ABI hex encoded form if required by the contract. Constructor arguments are written right to left and appear at the end of the created bytecode.",
  "contract_verification.hint.evm_version":
    "The EVM version the contract is written for. If the bytecode does not match the version, we try to verify using the latest EVM version.",
  "contract_verification.hint.evm_version_link": "EVM version details",
  "contract_verification.hint.zk_compiler": "zksolc compiler version.",
  "contract_verification.hint.contract_code_library":
    "If your code utilizes a library or inherits dependencies, we recommend using other verification methods instead.",
  "contract_verification.hint.contract_name": "Must match the name specified in the code.",
  "contract_verification.hint.contract_name_prefix": "Must match the name specified in the code. For example, in",
  "contract_verification.hint.contract_name_suffix": "is the contract name.",
  "contract_verification.hint.vyper_contract_name": "The contract name is the name assigned to the verified contract in the explorer.",
  "contract_verification.hint.standard_input": "Upload the standard input JSON file created during contract compilation.",
  "contract_verification.hint.multipart_sources": "Upload all Solidity or Yul contract source files.",
  "contract_verification.hint.multipart_sources_title": "Sources *.sol or *.yul files",
  "contract_verification.hint.sourcify_title": "Sources and Metadata JSON",
  "contract_verification.hint.sourcify": "Upload all Solidity contract source files and JSON metadata file(s) created during contract compilation.",
  "contract_verification.hint.vyper_multipart_main_title": "Upload main *.vy source",
  "contract_verification.hint.vyper_multipart_main":
    "Primary compiled Vyper contract. Only add the main contract here whose bytecode has been deployed; upload other files to the interfaces box below.",
  "contract_verification.hint.vyper_multipart_interfaces_title": "Interfaces (.vy or .json)",
  "contract_verification.hint.vyper_multipart_interfaces_prefix": "Add any",
  "contract_verification.hint.vyper_multipart_interfaces_link": "required interfaces",
  "contract_verification.hint.vyper_multipart_interfaces_suffix": "for the main compiled contract.",
  "contract_verification.hint.path_prefix":
    "The crate should be located in the root directory. If it is not the case, please specify the relative path from the root to the crate directory.",
  "contract_verification.hint.hardhat_tutorial": "Full tutorial about contract verification via Hardhat is available",
  "contract_verification.hint.hardhat_tutorial_link": "here",
  "contract_verification.hint.foundry_tutorial": "Full tutorial about contract verification via Foundry is available",
  "contract_verification.hint.foundry_tutorial_link": "here",
  "contract_verification.hint.latest_commit_found": "We have found the latest commit hash for the repository:",
  "contract_verification.hint.click_here": "click here",
  "contract_verification.file.drop_file": "Drop file or click here",
  "contract_verification.file.drop_files": "Drop files or click here",
  "contract_verification.file.field_required": "Field is required",
  "contract_verification.file.wrong_file_type": "Wrong file type. Allowed file types are {types}.",
  "contract_verification.file.file_too_big": "File is too big. Maximum size is 20 Mb.",
  "contract_verification.file.one_file_only": "You can upload only one file",
  "contract_verification.validation.github_not_found": "GitHub repository not found",
  "contract_verification.validation.invalid_github_url": "Invalid GitHub repository URL",
  "contract_verification.validation.commit_not_found": "Commit hash not found in the repository",

  "page.csv_export.title": "Export data to CSV file",
  "page.chart.select_resolution": "Select resolution",
  "page.chart.period": "Period",
  "page.chart.resolution": "Resolution",
  "page.chart.resolution_short": "Res.",
  "page.chart.menu.share": "Share",
  "page.chart.menu.copy_link": "Copy link",
  "page.chart.menu.view_fullscreen": "View fullscreen",
  "page.chart.menu.save_png": "Save as PNG",
  "page.chart.menu.save_csv": "Save as CSV",
  "page.chart.menu.options": "Open chart options menu",
  "page.stats.title": "{network} stats",
  "page.stats.title_with_data": "{network} statistic & data",
  "page.stats.all_stats": "All stats",
  "page.stats.find_chart": "Find chart, metric...",
  "page.stats.select_section": "Select section",
  "page.stats.chart_load_error": "Some of the charts did not load because the server didn't respond. To reload charts ",
  "page.stats.chart_load_error_link": "click once again.",
  "page.stats.empty_chart": "Couldn't find a chart that matches your filter query.",
  "stats.interval.all": "All time",
  "stats.interval.one_month": "1 month",
  "stats.interval.three_months": "3 months",
  "stats.interval.six_months": "6 months",
  "stats.interval.one_year": "1 year",
  "stats.resolution.day": "Day",
  "stats.resolution.week": "Week",
  "stats.resolution.month": "Month",
  "stats.resolution.year": "Year",
  "page.computor_transactions.title": "Computor transactions",
  "page.deposits.no_deposits": "There are no deposits.",
  "page.deposits.total_found": "A total of {count} deposits found",
  "page.dispute_games.no_dispute_games": "There are no dispute games.",
  "page.dispute_games.summary":
    "Dispute game index #{from} to #{to} (total of {count} games)",
  "page.epochs.no_epochs": "There are no epochs.",
  "page.transactions.blob_txns": "Blob txns",
  "page.transactions.pending": "Pending",
  "page.transactions.title": "Transactions",
  "page.transactions.title_with_network": "{network} transactions",
  "page.gas_tracker.faq": "FAQ",
  "page.gas_tracker.faq_a1":
    "Gas is the amount of native tokens required to perform a transaction on the blockchain.",
  "page.gas_tracker.faq_a2":
    "You can easily check live {network} gas fees on Blockscout by visiting our gas tracker. " +
    "It displays current gas fees in {unit} for all {network} transactions.",
  "page.gas_tracker.faq_a3":
    "The average gas fee for {network} transactions depends on network congestion and transaction complexity. " +
    "Blockscout provides real-time gas fee estimations to help users make informed decisions.",
  "page.gas_tracker.faq_a4":
    "Blockscout calculates gas fees based on the average price of gas fees spent for the last 200 blocks.",
  "page.gas_tracker.faq_q1": "What does gas refer to on the blockchain?",
  "page.gas_tracker.faq_q2": "How can I check {network} gas fees?",
  "page.gas_tracker.faq_q3":
    "What is the average gas fee for {network} transactions?",
  "page.gas_tracker.faq_q4": "How does Blockscout calculate gas fees?",
  "page.gas_tracker.last_updated": "Last updated",
  "page.gas_tracker.no_recent_data": "No recent data available",
  "page.gas_tracker.overview": "Gas tracker overview",
  "page.gas_tracker.price_history": "Gas price history",
  "page.gas_tracker.track_fees": "Track {network} gas fees",
  "page.gas_tracker.title_with_network": "{network} gas tracker",
  "page.internal_txs.empty_filtered":
    "Could not find any internal transaction that matches your query.",
  "page.internal_txs.no_internal_txs": "There are no internal transactions.",
  "page.internal_txs.placeholder": "Search by transaction hash",
  "page.interop_messages.no_messages": "There are no interop messages.",
  "page.interop_messages.total_found": "A total of {count} messages found",
  "page.mud_worlds.no_worlds": "There are no MUD worlds.",
  "page.my_profile.description":
    "You can add your email to receive watchlist notifications. " +
    "Additionally, you can manage your wallet address and email, which can be used for logging into your Blockscout account.",
  "page.my_profile.title": "My profile",
  "page.name.details": "Name details",
  "page.name_domains.empty_filtered":
    "Could not find name domains that match your filter query.",
  "page.name_domains.no_domains": "There are no name domains.",
  "page.name_domains.title_with_network": "{network} name domains",
  "page.operation.details": "Operation details",
  "page.operations.empty_filtered":
    "Could not find any operation that matches your query.",
  "page.operations.no_operations": "There are no operations.",
  "page.operations.placeholder": "Search by operation, tx hash, sender",
  "page.output_roots.no_output_roots": "There are no output roots.",
  "page.output_roots.summary":
    "L2 output index #{from} to #{to} (total of {count} roots)",
  "page.pools.no_pools": "There are no pools.",
  "page.pools.empty_filtered":
    "Could not find pools that match your filter query.",
  "page.pools.placeholder": "Pair, token symbol or token address",
  "page.pool.lp_token_hint":
    "This Liquidity Provider (LP) token represents {base}/{quote} pairing.",
  "page.marketplace.placeholder": "Find app by name or keyword...",
  "page.search_result.title": "Search result",
  "page.search_result.matching_results":
    "Found {count}{plus} matching result{plural} for",
  "page.search_results.title": "Search results",
  "page.search_results.result_header": "Search result",
  "page.sol2uml.title": "Solidity UML diagram",
  "page.sol2uml.for_contract": "For contract",
  "page.txn_batches.no_txn_batches": "There are no txn batches.",
  "page.txn_batches.summary":
    "Txn batch #{from} to #{to} (total of {count} batches)",
  "page.txn_withdrawals.empty_filtered":
    "Could not find any withdrawals for your transaction.",
  "page.txn_withdrawals.invalid_tx_hash": "Invalid transaction hash",
  "page.txn_withdrawals.relayer_hint":
    "L2 to L1 message relayer: search for your L2 transaction to execute a manual withdrawal.",
  "page.transaction.confidential_compute_tx_details":
    "Confidential compute tx details",
  "page.transaction.details": "Transaction details",
  "page.transaction.details_on": "Transaction details on {network}",
  "page.transaction.regular_tx_details": "Regular tx details",
  "page.transaction_info": "Transaction info",
  "page.token.unnamed_token": "Unnamed token",
  "page.token.price_hint": "Price per token on the exchanges",
  "page.token.market_cap_hint": "Circulating supply * Price",
  "page.token.max_total_supply_hint": "The total amount of tokens issued",
  "page.token.holders_hint": "Number of accounts holding the token",
  "page.token.transfers_count_hint": "Number of transfer for the token",
  "page.token.decimals_hint": "Number of digits that come after the decimal place when displaying token value",
  "page.token.marketplaces": "Marketplaces",
  "page.token.marketplaces_hint": "Marketplaces trading this NFT",
  "page.user_op.details": "User operation details",
  "page.user_ops.no_user_ops": "There are no user operations.",
  "page.validator.details": "Validator details",
  "page.validators.empty_filtered":
    "Could not find any validator that matches your query.",
  "page.validators.no_validators": "There are no validators.",
  "page.verified_contracts.empty_filtered":
    "Could not find any contract that matches your query.",
  "page.verified_contracts.no_verified_contracts":
    "There are no verified contracts.",
  "page.verified_contracts.placeholder": "Search by contract name or address",
  "page.verified_contracts.sort_balance_asc": "Balance ascending",
  "page.verified_contracts.sort_balance_desc": "Balance descending",
  "page.verified_contracts.sort_txs_count_asc": "Txs count ascending",
  "page.verified_contracts.sort_txs_count_desc": "Txs count descending",
  "page.verified_contracts.title_with_network": "Verified {network} contracts",
  "page.withdrawals.no_withdrawals": "There are no withdrawals.",
  "page.withdrawals.processed_summary":
    "{count} withdrawals processed and {value} {symbol} withdrawn",
  "page.withdrawals.title_with_network": "{network} withdrawals",
  "page.withdrawals.total_found": "A total of {count} withdrawals found",
  "page.user_ops.title_with_network": "{network} user operations",
  "page.verified_addresses.my_title": "My verified addresses",
  "page.verified_addresses.back_to_my": "Back to my verified addresses",
  "page.verified_addresses.before_start": "Before starting, make sure that:",
  "page.verified_addresses.deployed_on":
    'The source code for the smart contract is deployed on "{network}".',
  "page.verified_addresses.description":
    "Verify ownership of a smart contract address to easily update information in Blockscout. " +
    "You will sign a single message to verify contract ownership. Once verified, you can update token information, " +
    "address name tags, and address labels from the Blockscout console without needing to sign additional messages.",
  "page.verified_addresses.get_started":
    "Once these steps are complete, click the Add address button below to get started.",
  "page.verified_addresses.token_info_form": "Token info application form",
  "page.verified_addresses.verified_source_code_prefix":
    "The source code is verified (if not yet verified, you can use ",
  "page.verified_addresses.verified_source_code_suffix": ").",
  "page.watch_list.description":
    "An email notification can be sent to you when an address on your watch list sends or receives any transactions.",
  "network.view_all_chains": "View all chains",
  "search.category.addresses": "Addresses",
  "search.category.blobs": "Blobs",
  "search.category.blocks": "Blocks",
  "search.category.dapps": "DApps",
  "search.category.names": "Names",
  "search.category.nfts": "NFTs ({standard}-721 & 1155)",
  "search.category.operations": "Operations",
  "search.category.public_tags": "Public tags",
  "search.category.tokens": "Tokens ({standard}-20)",
  "search.category.transactions": "Transactions",
  "search.category.user_operations": "User operations",
  "search.loading": "We are searching, please wait...",
  "search.placeholder_desktop":
    "Search by address / txn hash / block / token... ",
  "search.placeholder_mobile": "Search by address / ... ",
  "search.recent": "Recent",
  "search.clear_all": "Clear all",
  "settings.color_theme": "Color theme",
  "settings.show_address_format": "Show {prefix} format",
  "socket.connection_lost_link": "to load newer records",
  "socket.connection_lost_prefix": "Connection lost, click ",
  "socket.live_updates_delayed": "Live updates temporarily delayed",
  "socket.item.block": "block",
  "socket.item.deposit": "deposit",
  "socket.item.token_transfer": "token transfer",
  "socket.item.transaction": "transaction",
  "socket.more_items": "{num} more {name}{plural} ha{verb} come in",
  "socket.scanning_new_items": "scanning new {namePlural}...",
  "home.network_utilization_last_blocks":
    "Network utilization (last {count} blocks):",
  "block.reorg_height": "Reorg height",
  "block.uncle_height": "Uncle height",
  "block.genesis_block": " - Genesis Block",
  "block.l1_height_hint": "The most recent L1 block height as of this L2 block",
  "block.batch_hint": "Batch number",
  "block.status_hint":
    "Status is the short interpretation of the batch lifecycle",
  "block.miner_hint":
    "A block producer who successfully included the block onto the blockchain",
  "block.commitment_tx_hint": "L1 transaction containing this batch commitment",
  "block.confirmation_tx_hint":
    "L1 transaction containing confirmation of this batch",
  "block.reward_hint":
    "For each block, the {validatorTitle} is rewarded with a finite amount of {symbol} on top of the fees paid for all transactions in the block",
  "block.reward_amount_hint":
    "Amount of distributed reward. {validatorTitle}s receive a static block reward + Tx fees + uncle fees",
  "block.static_reward": "Static block reward",
  "block.txn_fees": "Txn fees",
  "block.burnt_fees": "Burnt fees",
  "block.view_hint":
    "The iteration of the consensus round in which the block was proposed",
  "block.gas_used_hint":
    "The total gas amount used in the block and its percentage of gas filled in the block",
  "block.gas_limit_hint":
    "Total gas limit provided by all transactions in the block",
  "block.min_gas_price": "Minimum gas price",
  "block.min_gas_price_hint":
    "The minimum gas price a transaction should have in order to be included in this block",
  "block.base_fee_per_gas": "Base fee per gas",
  "block.base_fee_per_gas_hint":
    "Minimum fee required per unit of gas. Fee adjusts based on network congestion",
  "block.burnt_fees_hint":
    "Amount of {symbol} burned from transactions included in the block. Equals Block Base Fee per Gas * Gas Used",
  "block.burnt_fees_utilization_hint": "Burnt fees / Txn fees * 100%",
  "block.priority_fee": "Priority fee / Tip",
  "block.priority_fee_hint":
    "User-defined tips sent to validator for transaction priority/inclusion",
  "block.difficulty_hint":
    "Block difficulty for {validatorTitle}, used to calibrate block generation time",
  "block.total_difficulty_hint":
    "Total difficulty of the chain until this block",
  "block.hash_hint": "The SHA256 hash of the block",
  "block.parent_hash_hint":
    "The hash of the block from which this block was generated",
  "block.nonce_hint":
    "Block nonce is a value used during mining to demonstrate proof of work for a block",
  "block.send_count": "Send count",
  "block.send_count_hint":
    "The cumulative number of L2 to L1 transactions as of this block",
  "block.send_root": "Send root",
  "block.send_root_hint":
    "The root of the Merkle accumulator representing all L2 to L1 transactions as of this block",
  "block.delayed_messages": "Delayed messages",
  "block.delayed_messages_hint":
    "The number of delayed L1 to L2 messages read as of this block",
  "block.tx_count_label": "{count} txn{plural}",
  "block.blob_tx_count_label": "{count} blob txn{plural}",
  "block.including": " including ",
  "block.in_this_block": " in this block",
  "block.height_hint":
    "The block height of a particular block is defined as the number of blocks preceding it in the blockchain",
  "block.size_hint": "Size of the block in bytes",
  "block.timestamp_hint": "Date & time at which block was produced.",
  "block.transactions_hint": "The number of transactions in the block",
  "block.withdrawals_hint": "The number of beacon withdrawals in the block",
  "block.difficulty": "Difficulty",
  "block.total_difficulty": "Total difficulty",
  "block.hash": "Hash",
  "block.parent_hash": "Parent hash",
  "tx.state.description":
    "A set of information representing the current state is updated when transactions occur on the network. Below is a summary of those changes.",
  "tx.state.empty": "There are no state changes for this transaction.",
  "tx.state.before_change": "Before change",
  "tx.state.after_change": "After change",
  "tx.state.change_amount": "Change amount",
  "tx.state.mint_address": "Mint address",
  "tx.state.burn_address": "Burn address",
  "tx.state.miner_tooltip":
    "A block producer that successfully includes the block in the blockchain",
  "tx.state.mint_burn_tooltip":
    "An address used for token minting and burning operations",
  "tx.raw_trace.empty": "No raw traces found.",
  "tx.logs.empty": "There are no logs for this transaction.",
  "tx.blobs.empty": "There are no blobs for this transaction.",
  "tx.blobs.blob_hash": "Blob hash",
  "tx.blobs.data_type": "Data type",
  "tx.internals.empty":
    "There are no internal transactions for this transaction.",
  "tx.internals.gas_limit": "Gas limit",
  "tx.internal.type.call": "Call",
  "tx.internal.type.delegatecall": "Delegate call",
  "tx.internal.type.staticcall": "Static call",
  "tx.internal.type.create": "Create",
  "tx.internal.type.create2": "Create2",
  "tx.internal.type.selfdestruct": "Self-destruct",
  "tx.internal.type.reward": "Reward",
  "tx.token_transfers.empty":
    "There are no token transfers for this transaction.",
  "tx.token_transfers.empty_filtered":
    "No token transfers found matching the filter.",
  "tx.type.contract_call": "Contract call",
  "tx.type.blob_transaction": "Blob txn",
  "tx.type.token_transfer": "Token transfer",
  "tx.type.token_creation": "Token creation",
  "tx.type.rootstock_remasc": "REMASC",
  "tx.type.rootstock_bridge": "Bridge",
  "tx.type.transaction": "Transaction",
  "tx.asset_flows.wallet": "Wallet",
  "tx.asset_flows.actions": "Actions",
  "tx.asset_flows.empty": "There are no transfers for this transaction.",
  "tx.authorizations.empty":
    "There are no authorization records for this transaction.",
  "tx.authorizations.authority": "Authorizer",
  "tx.authorizations.chain": "Chain",
  "tx.authorizations.chain_this": "this",
  "tx.authorizations.chain_any": "any",
  "common.additional_info": "Additional info",
  "common.txn_type": "Txn type",
  "common.more_details": "More details",
  "tx.hint.transaction_hash": "Unique character string (TxID) assigned to every verified transaction",
  "tx.hint.status": "Current transaction state: Success, Failed (Error), or Pending (In Process)",
  "tx.hint.status_details": "Detailed status progress of the transaction",
  "tx.hint.l1_status": "Status of the transaction confirmation path to L1",
  "tx.hint.revert_reason": "The revert reason of the transaction",
  "tx.hint.batch_lifecycle": "Status is the short interpretation of the batch lifecycle",
  "tx.hint.block": "Block number containing the transaction",
  "tx.hint.batch_index": "Batch index for this transaction",
  "tx.hint.batch_number": "Batch number",
  "tx.hint.batch_index_in_block": "Index of the batch containing this transaction",
  "tx.hint.timestamp": "Date & time of transaction inclusion, including length of time for confirmation",
  "tx.hint.confidential_node": "Node that carried out the confidential computation",
  "tx.hint.from": "Address (external or contract) sending the transaction",
  "tx.hint.to": "Address (external or contract) receiving the transaction",
  "tx.hint.interop_target": "The target address where this cross-chain transaction is executed",
  "tx.hint.commitment_tx": "L1 transaction containing this batch commitment",
  "tx.hint.confirmation_tx": "L1 transaction containing confirmation of this batch",
  "tx.hint.value": "Value sent in the native token (and USD) if applicable",
  "tx.hint.fee": "Total transaction fee",
  "tx.hint.fee_without_blob": "Transaction fee without blob fee",
  "tx.hint.poster_fee": "Fee paid to the poster for L1 resources",
  "tx.hint.execution_fee": "Fee paid to the network for L2 resources",
  "tx.hint.gas_used": "Actual gas amount used by the transaction",
  "tx.hint.l1_data_gas": "L2 gas set aside for L1 data charges",
  "tx.hint.l2_gas_used": "L2 gas spent on L2 resources",
  "tx.hint.l1_gas_used": "Total gas used on L1",
  "tx.hint.l1_gas_used_by_txn": "L1 gas used by transaction",
  "tx.hint.l1_gas_price": "L1 gas price",
  "tx.hint.l1_data_fee": "L1 Data Fee which is used to cover the L1 \"security\" cost from the batch submission mechanism. In combination with L2 execution fee, L1 fee makes the total amount of fees that a transaction pays.",
  "tx.hint.l1_fee_scalar": "A Dynamic overhead (fee scalar) premium, which serves as a buffer in case L1 prices rapidly increase.",
  "tx.hint.gas_fees_breakdown": "Base Fee refers to the network Base Fee at the time of the block, while Max Fee & Max Priority Fee refer to the max amount a user is willing to pay for their tx & to give to the {validatorTitle} respectively",
  "tx.hint.blob_fee": "Blob fee for this transaction",
  "tx.hint.blob_gas_used": "Amount of gas used by the blobs in this transaction",
  "tx.hint.blob_eth_used": "Amount of {symbol} used for blobs in this transaction",
  "tx.hint.input_data": "Binary data included with the transaction. See logs tab for additional info",
  "tx.hint.decoded_input_data": "Decoded input data",
  "tx.hint.gas_limit": "Maximum amount of gas that can be used by the transaction",
  "block.merged_mining.bitcoin_header": "Bitcoin merged mining header",
  "block.merged_mining.coinbase_txn": "Bitcoin merged mining coinbase transaction",
  "block.merged_mining.merkle_proof": "Bitcoin merged mining Merkle proof",
  "block.merged_mining.rootstock_hash": "Hash for merged mining",
  "block.celo_base_fee.handler_label": "Base fee handler",
  "block.celo_base_fee.handler_hint": "The contract receiving the base fee, responsible for handling fee usage. This contract is controlled by governance process.",
  "block.celo_base_fee.total_label": "Base fee total",
  "block.celo_base_fee.total_hint_prefix": "The FeeHandler regularly burns 80% of its tokens. Non-CELO tokens are swapped to CELO beforehand. The remaining 20% are sent to the ",
  "block.celo_base_fee.total_hint_suffix": ".",
  "block.celo_base_fee.burnt": "burnt",
  "block.celo_base_fee.percentage_of_amount": "{percentage}% of amount",
  "block.blob_info.price_label": "Blob gas price",
  "block.blob_info.price_hint": "Price per unit of gas used for for blob deployment. Blob gas is independent of normal gas. Both gas prices can affect the priority of transaction execution.",
  "block.blob_info.used_label": "Blob gas used",
  "block.blob_info.used_hint": "Actual amount of gas used by the blobs in this block",
  "block.blob_info.burnt_label": "Blob burnt fees",
  "block.blob_info.burnt_hint": "Amount of {symbol} used for blobs in this block",
  "block.blob_info.utilization_tooltip": "Blob burnt fees / Txn fees * 100%",
  "block.blob_info.excess_label": "Excess blob gas",
  "block.blob_info.excess_hint": "A running total of blob gas consumed in excess of the target, prior to the block.",
  "block.zilliqa_qc.consensus_explanation": "The iteration of the consensus round in which the block was proposed:",
  "block.zilliqa_qc.view_explanation": "View - the view number of the quorum certificate, indicating the consensus round.",
  "block.zilliqa_qc.signature_explanation": "Signature - aggregated BLS signature representing the validators' agreement.",
  "block.zilliqa_qc.signers_explanation": "Signers - an array of integers representing the indices of validators who participated in the quorum (indicated by the cosigned bit vector).",
  "block.zilliqa_qc.proposed_explanation": "Proposed by validator - validator index proposing the nested quorum certificate.",
  "block.zilliqa_qc.aggregate_quorum_certificate": "Aggregate quorum certificate",
  "block.zilliqa_qc.quorum_certificate": "Quorum certificate",
  "block.zilliqa_qc.view": "View",
  "block.zilliqa_qc.signature": "Signature",
  "block.zilliqa_qc.signers": "Signers",
  "block.zilliqa_qc.nested_quorum_certificates": "Nested quorum certificates",
  "block.zilliqa_qc.proposed_by_validator": "Proposed by validator",
  "tx.allowed_peekers.label": "Allowed peekers",
  "tx.allowed_peekers.hint": "Smart contracts allowed to interact with confidential data",
  "tx.scroll_fees.l1_fee_hint": "L1 fee that pays for rollup costs",
  "tx.scroll_fees.l2_fee_hint": "L2 execution fee",
  "tx.scroll_fees.scalar_hint": "Commitment scalar",
  "tx.scroll_fees.overhead_hint": "Additional gas overhead of a data commitment transaction",
  "tx.scroll_fees.l1_gas_fees_hint": "L1 gas fees",
  "tx.scroll_fees.l1_blob_fees_hint": "L1 blob fees",
  "tx.fee_per_gas.hint": "Fee per gas",
  "tx.interop.source_txn_hint": "The originating transaction that initiated the cross-L2 message on the source chain",
  "tx.interop.relay_txn_hint": "The transaction that relays the cross-L2 message to its destination chain",
  "tx.withdrawal_status_arbitrum.status_hint": "Detailed status progress of the transaction",
  "tx.withdrawal_status_arbitrum.origin_txn_hint": "The hash of the transaction that originated the message from the base layer",
  "tx.gas_price.hint": "Price per unit of gas specified by the sender. Higher gas prices can prioritize transaction inclusion during times of high usage",
  "tx.other.hint": "Other data related to this transaction",
  "blob.info.not_indexed": "This blob is not yet indexed",
  "blob.info.proof_label": "Proof",
  "blob.info.proof_hint": "Zero knowledge proof. Allows for quick verification of commitment",
  "blob.info.commitment_label": "Commitment",
  "blob.info.commitment_hint": "Commitment to the data in the blob",
  "blob.info.size_label": "Size, bytes",
  "blob.info.size_hint": "Blob size in bytes",
  "blob.info.txn_hash_label": "Transaction hash",
  "blob.info.txn_hash_hint": "Hash of the transaction with this blob",
  "blob.data.not_an_image": "Not an image",
  "blob.data.title": "Blob data",
  "blob.data.select_type": "Select type",
  "blob.data.download": "Download",
  "blob.data.format.image": "Image",
  "blob.data.format.raw": "Raw",
  "blob.data.format.utf8": "UTF-8",
  "blob.data.format.base64": "Base64",
  "common.originating_l1_txn_hash": "Originating L1 txn hash",
  "tx.hint.method": "Transaction method name",
  "stats.chart.incomplete_resolution": "Incomplete {resolution}",
  "stats.tooltip.date": "Date",
  "stats.tooltip.dates": "Dates",
  "stats.tooltip.month": "Month",
  "stats.tooltip.year": "Year",
  "stats.tooltip.value": "Value",
  "stats.counter.averageBlockTime.title": "Average block time",
  "stats.counter.averageBlockTime.description": "Average time taken in seconds for a block to be included in the blockchain",
  "stats.counter.completedTxns.title": "Completed txns",
  "stats.counter.completedTxns.description": "Number of transactions with success status",
  "stats.counter.lastNewContracts.title": "Number of contracts today",
  "stats.counter.lastNewContracts.description": "Number of deployed contracts today (UTC)",
  "stats.counter.lastNewVerifiedContracts.title": "Number of verified contracts today",
  "stats.counter.lastNewVerifiedContracts.description": "Number of contracts verified today (UTC)",
  "stats.counter.totalAccounts.title": "Total accounts",
  "stats.counter.totalAccounts.description": "Number of EOAs that sent at least 1 transaction",
  "stats.counter.totalAddresses.title": "Total addresses",
  "stats.counter.totalAddresses.description": "Number of addresses that participated in the blockchain",
  "stats.counter.totalBlocks.title": "Total blocks",
  "stats.counter.totalBlocks.description": "Number of blocks over all time",
  "stats.counter.totalContracts.title": "Total contracts",
  "stats.counter.totalContracts.description": "Number of contracts",
  "stats.counter.totalNativeCoinTransfers.title": "Total ETH transfers",
  "stats.counter.totalNativeCoinTransfers.description": "Number of transactions with the transfer of the ETH",
  "stats.counter.totalTokens.title": "Total tokens",
  "stats.counter.totalTokens.description": "Number of all token contracts",
  "stats.counter.totalTxns.title": "Total txns",
  "stats.counter.totalTxns.description": "All transactions including pending, dropped, replaced, failed transactions",
  "stats.counter.totalVerifiedContracts.title": "Total verified contracts",
  "stats.counter.totalVerifiedContracts.description": "Number of verified contracts",
  "stats.counter.newTxns24h.title": "Transactions (24h)",
  "stats.counter.newTxns24h.description": "Number of new transactions within the last 24 hours",
  "stats.counter.pendingTxns30m.title": "Pending transactions (30m)",
  "stats.counter.pendingTxns30m.description": "Transactions in the past 30 minutes waiting to be processed by the network",
  "stats.counter.txnsFee24h.title": "Transactions fees (24h)",
  "stats.counter.txnsFee24h.description": "Sum of ETH spent on gas fees within the last 24 hours",
  "stats.counter.averageTxnFee24h.title": "Avg. transaction fee (24h)",
  "stats.counter.averageTxnFee24h.description": "Average amount of ETH spent on gas fees per transaction within the last 24 hours",
  "stats.section.accounts.title": "Accounts",
  "stats.section.transactions.title": "Transactions",
  "stats.section.blocks.title": "Blocks",
  "stats.section.tokens.title": "Tokens",
  "stats.section.gas.title": "Gas",
  "stats.section.contracts.title": "Contracts",
  "stats.section.user_ops.title": "User operations",
  "stats.chart.accountsGrowth.title": "Number of accounts",
  "stats.chart.accountsGrowth.description": "Cumulative account growth over time",
  "stats.chart.activeAccounts.title": "Active accounts",
  "stats.chart.activeAccounts.description": "Active accounts number per period",
  "stats.chart.newAccounts.title": "New accounts",
  "stats.chart.newAccounts.description": "Number of newly added accounts",
  "stats.chart.averageTxnFee.title": "Average transaction fee",
  "stats.chart.averageTxnFee.description": "Average amount of ETH spent on gas fees per transaction",
  "stats.chart.newTxns.title": "New transactions",
  "stats.chart.newTxns.description": "Number of new transactions",
  "stats.chart.txnsFee.title": "Transaction fees",
  "stats.chart.txnsFee.description": "Sum of ETH spent on gas fees",
  "stats.chart.txnsGrowth.title": "Number of transactions",
  "stats.chart.txnsGrowth.description": "Cumulative transaction growth over time",
  "stats.chart.txnsSuccessRate.title": "Transaction success rate",
  "stats.chart.txnsSuccessRate.description": "Success rate for all included transactions",
  "stats.chart.averageBlockRewards.title": "Average block rewards",
  "stats.chart.averageBlockRewards.description": "Average amount of reward",
  "stats.chart.averageBlockSize.title": "Average block size",
  "stats.chart.averageBlockSize.description": "Space (in bytes) taken up by all block fields",
  "stats.chart.newBlocks.title": "New blocks",
  "stats.chart.newBlocks.description": "Number of new blocks added to the chain",
  "stats.chart.newNativeCoinTransfers.title": "Number of ETH transfers",
  "stats.chart.newNativeCoinTransfers.description": "Completed token transfers",
  "stats.chart.averageGasLimit.title": "Average gas limit",
  "stats.chart.averageGasLimit.description": "Average block gas limit",
  "stats.chart.averageGasPrice.title": "Average gas price",
  "stats.chart.averageGasPrice.description": "Average price (Gwei) per unit of gas",
  "stats.chart.gasUsedGrowth.title": "Total gas usage",
  "stats.chart.gasUsedGrowth.description": "Cumulative gas used over time",
  "stats.chart.networkUtilization.title": "Network utilization",
  "stats.chart.networkUtilization.description": "Percentage of gas used compared to the gas limit",
  "stats.chart.averageGasUsed.title": "Average gas used",
  "stats.chart.averageGasUsed.description": "Average amount of gas used per block",
  "stats.chart.contractsGrowth.title": "Number of contracts",
  "stats.chart.contractsGrowth.description": "Cumulative contract growth over time",
  "stats.chart.newContracts.title": "New contracts",
  "stats.chart.newContracts.description": "Number of new contracts in the network",
  "stats.chart.newVerifiedContracts.title": "New verified contracts",
  "stats.chart.newVerifiedContracts.description": "Number of newly verified contracts",
  "stats.chart.verifiedContractsGrowth.title": "Number of verified contracts",
  "stats.chart.verifiedContractsGrowth.description": "Cumulative verified contract growth over time",
};

const zhCN: Record<TranslationKey, string> = {
  "app_error.403.text": "访问该资源受限。",
  "app_error.403.title": "提醒",
  "app_error.404.text": "该页面已无法浏览。你可以使用搜索栏查找所需内容。",
  "app_error.404.title": "页面未找到",
  "app_error.422.text":
    "请求中包含错误，可能是交易、区块或地址哈希输入有误。请检查后重试。",
  "app_error.422.title": "请求无法处理",
  "app_error.500.text": "发生了意外错误。请重新加载页面，或稍后再试。",
  "app_error.500.title": "糟糕，出现问题了",
  "common.age": "时间",
  "common.add_address": "添加地址",
  "common.add_api_key": "添加 API 密钥",
  "common.add_token_to_wallet": "添加代币到{wallet}",
  "common.apple": "Apple",
  "common.all": "全部",
  "common.address": "地址",
  "common.api_documentation_unavailable": "暂无 API 文档",
  "common.back_to_home": "返回首页",
  "common.balance": "余额",
  "common.balance_with_symbol": "余额 {symbol}",
  "common.base_fee": "基础费用",
  "common.block": "区块",
  "common.block_confirmations": "{count} 个区块确认",
  "common.burnt_fees": "销毁费用",
  "common.bytes": "字节",
  "common.call": "调用",
  "common.batch": "批次",
  "common.category": "分类",
  "common.constructor_args": "构造参数",
  "common.contract": "合约",
  "common.contract_address": "合约地址",
  "common.copy": "复制",
  "common.copy_link_to_clipboard": "复制链接到剪贴板",
  "common.copy_to_clipboard": "复制到剪贴板",
  "common.copied": "已复制",
  "common.current_block": "当前区块",
  "common.default": "默认",
  "common.details": "详情",
  "common.documentation": "文档",
  "common.error.try_refresh": "出现了一些问题。请刷新页面，或稍后再试。",
  "common.estimated_target_date": "预计目标日期",
  "common.fast": "快速",
  "common.fee": "手续费",
  "common.filter": "筛选",
  "common.first": "首页",
  "common.from": "来自",
  "common.from_to": "从/到",
  "common.gas_used": "Gas 使用量",
  "common.google": "Google",
  "common.hide": "隐藏",
  "common.hide_details": "隐藏详情",
  "common.hide_scam_tokens": "隐藏风险代币",
  "common.history": "历史",
  "common.how_to_use_blockscout_api_key": "如何使用 Blockscout API 密钥",
  "common.hex": "十六进制",
  "common.info": "信息",
  "common.inventory": "库存",
  "common.l1_txn": "L1 交易",
  "common.l1_txn_hash": "L1 交易哈希",
  "common.l2_txn": "L2 交易",
  "common.l2_txn_hash": "L2 交易哈希",
  "common.l2_block_no": "L2 区块号",
  "common.language": "语言",
  "common.language_compiler_version": "语言 / 编译器版本",
  "common.last_update": "最后更新",
  "common.left": "剩余",
  "common.links": "链接",
  "common.load_high": "高负载",
  "common.load_low": "低负载",
  "common.load_medium": "中等负载",
  "common.license": "许可证",
  "common.logs": "日志",
  "common.lookup_related_domains": "查找相关域名",
  "common.loading": "数据加载中，请稍候...",
  "common.need_help_contact_admin": "需要帮助？请联系管理员团队：",
  "common.normal": "普通",
  "common.no_data": "暂无数据，请刷新页面。",
  "common.no_data_selected_interval": "所选分辨率和时间区间暂无数据。",
  "common.no_data_short": "暂无数据",
  "common.no_blocks": "暂无区块。",
  "common.no_results": "暂无结果",
  "common.no_results_found": "未找到结果。",
  "common.no_transactions": "暂无交易。",
  "common.holder": "持有人",
  "common.holders": "持有人",
  "common.id_short": "ID#",
  "common.index": "索引",
  "common.on_chain_market_cap": "链上市值",
  "common.owner": "拥有者",
  "common.optimization": "优化",
  "common.parent_txn_hash": "父交易哈希",
  "common.per_transaction": "每笔交易",
  "common.percentage": "占比",
  "common.pending_claim": "待领取",
  "common.prev_page": "上一页",
  "common.next_page": "下一页",
  "common.price": "价格",
  "common.priority": "优先费",
  "common.quantity": "数量",
  "common.rank": "排名",
  "common.raw": "原始数据",
  "common.remaining_blocks": "剩余区块",
  "common.reset": "重置",
  "common.reset_zoom": "重置缩放",
  "common.reward": "奖励",
  "common.sender": "发送方",
  "common.select_chain": "选择链",
  "common.select_interval": "选择时间区间",
  "common.select_type": "选择类型",
  "common.settings": "设置",
  "common.size": "大小",
  "common.size_bytes": "大小，字节",
  "common.slow": "慢速",
  "common.show_info": "显示信息",
  "common.status": "状态",
  "common.success": "成功",
  "common.failed": "失败",
  "common.pending": "待处理",
  "common.timestamp": "时间戳",
  "common.time_left": "剩余时间",
  "common.this_tool": "这个工具",
  "common.to": "到",
  "common.testnet_transaction_only": "这是一笔仅限测试网的交易",
  "common.toggle_time_format": "切换时间格式",
  "common.total_contracts": "合约总数",
  "common.transfers": "转账",
  "common.txn": "交易",
  "common.txn_count": "交易数",
  "common.txn_hash": "交易哈希",
  "common.tx_hash": "交易哈希",
  "common.txs": "交易",
  "common.type": "类型",
  "common.utf8": "UTF-8",
  "common.method": "方法",
  "common.method_id": "方法 ID",
  "common.msg_nonce": "消息 nonce",
  "common.name": "名称",
  "common.token": "代币",
  "common.token_id": "代币 ID",
  "common.user_op_hash": "用户操作哈希",
  "common.user": "用户",
  "common.validator_index": "验证者索引",
  "common.value": "数值",
  "common.view_all": "查看全部",
  "common.view_details": "查看详情",
  "common.view_all_results": "查看全部结果",
  "common.verified": "已验证",
  "common.verified_contracts": "已验证合约",
  "common.verify_with": "验证源",
  "common.verify_with_other_explorers": "使用其他浏览器验证",
  "common.website_settings": "网站设置",
  "common.widgets": "组件",
  "common.zk_compiler": "ZK 编译器",
  "common.for_assistance": " 获取帮助！",
  "common.account_history": "账户历史",
  "common.address_from": "发送地址",
  "common.address_to": "接收地址",
  "common.amount": "数量",
  "common.amount_from": "数量起始值",
  "common.amount_to": "数量结束值",
  "common.and_or": "与/或",
  "common.api_documentation": "API 文档",
  "common.asset": "资产",
  "common.asset_flows": "资产流向",
  "common.authorizations": "授权",
  "common.base": "基础",
  "common.blob_fee": "Blob 费用",
  "common.blob_gas_fees": "Blob Gas 费用",
  "common.blob_gas_usage": "Blob Gas 使用量",
  "common.blobs": "Blobs",
  "common.code": "代码",
  "common.coin_transfer": "原生币转账",
  "common.coin_balance_history": "原生币余额历史",
  "common.columns": "列",
  "common.commitment_tx": "提交交易",
  "common.confirmation_status": "确认状态",
  "common.confirmation_tx": "确认交易",
  "common.contract_creation": "合约创建",
  "common.confirmed_within": "在 {lower} 秒内确认",
  "common.confirmed_within_lte": "在 <= {upper} 秒内确认",
  "common.confirmed_within_range": "在 {lower} - {upper} 秒内确认",
  "common.date_from": "开始日期",
  "common.date_to": "结束日期",
  "common.data": "数据",
  "common.decimals": "小数位",
  "common.decoded_input_data": "已解码输入数据",
  "common.dapp": "DApp",
  "common.epoch_rewards": "Epoch 奖励",
  "common.eth_rpc_api": "ETH RPC API",
  "common.exclude": "排除",
  "common.find_by_function_name_method_id": "按函数名/方法 ID 查找",
  "common.finalized": "已最终确认",
  "common.gas_fees": "Gas 费用",
  "common.gas_limit": "Gas 上限",
  "common.gas_price": "Gas 价格",
  "common.gas_used_for_l1": "用于 L1 的 Gas",
  "common.gas_used_for_l2": "用于 L2 的 Gas",
  "common.gas_usage_and_limit_by_txn": "交易 Gas 使用量与上限",
  "common.graphql_api": "GraphQL API",
  "common.include": "包含",
  "common.indexed": "已索引?",
  "common.incoming_message": "传入消息",
  "common.interacted_with_contract": "与合约交互",
  "common.internal_txns": "内部交易",
  "common.interop_target": "互操作目标",
  "common.kettle": "Kettle",
  "common.l1_fee": "L1 费用",
  "common.l1_fee_scalar": "L1 费用系数",
  "common.l1_gas_price": "L1 Gas 价格",
  "common.l1_gas_used": "L1 Gas 使用量",
  "common.l1_gas_used_by_txn": "交易使用的 L1 Gas",
  "common.l1_status": "L1 状态",
  "common.l2_status_and_method": "L2 状态与方法",
  "common.market_cap": "市值",
  "common.max": "最大",
  "common.max_priority": "最大优先费",
  "common.max_total_supply": "最大总供应量",
  "common.metadata": "元数据",
  "common.network_fee": "网络费用",
  "common.no_tokens_found": "未找到代币",
  "common.nonce": "Nonce",
  "common.outgoing_message": "传出消息",
  "common.popular": "热门",
  "common.poster_fee": "发布者费用",
  "common.raw_input": "原始输入",
  "common.raw_trace": "原始追踪",
  "common.revert_reason": "回退原因",
  "common.rest_api": "REST API",
  "common.rpc_api_endpoints": "RPC API 端点",
  "common.select_mode": "选择模式",
  "common.sequence_tx_hash": "排序交易哈希",
  "common.smart_contract_or_address": "智能合约 / 地址 (0x...)*",
  "common.show_all": "显示全部",
  "common.syncing_with_base_layer": "与基础层同步中",
  "common.state": "状态",
  "common.status_and_method": "状态与方法",
  "common.validated_by": "验证者",
  "common.contract_execution_completed": "合约执行完成",
  "common.contract_execution_error": "合约执行过程中发生错误",
  "common.contract_execution_status": "合约执行状态",
  "common.could_not_determine": "无法确定",
  "common.execution_fee": "执行费用",
  "common.blocks_mined": "已挖出区块",
  "common.blocks_posted": "已提交区块",
  "common.blocks_sequenced": "已排序区块",
  "common.blocks_validated": "已验证区块",
  "common.interop_relay_tx": "互操作中继交易",
  "common.interop_source_tx": "互操作源交易",
  "common.interop_status": "互操作状态",
  "common.l1_commit_scalar": "L1 提交系数",
  "common.l1_block_height": "L1 区块高度",
  "common.l1_blob_fees": "L1 Blob 费用",
  "common.l1_data_fee": "L1 数据费用",
  "common.l1_fee_overhead": "L1 费用开销",
  "common.l1_gas_fees": "L1 Gas 费用",
  "common.message_id": "消息 ID",
  "common.mined_by": "出块者",
  "common.other": "其他",
  "common.payload": "负载",
  "common.position": "位置",
  "common.posted_by": "提交者",
  "common.queue_index": "队列索引",
  "common.ready_for_relay": "可中继",
  "common.relayed": "已中继",
  "common.reorged_block": "重组区块",
  "common.scalar": "系数",
  "common.sequenced_by": "排序者",
  "common.settlement_pending": "结算待处理",
  "common.target": "目标",
  "common.tokens_burnt": "已销毁代币",
  "common.tokens_created": "已创建代币",
  "common.tokens_minted": "已铸造代币",
  "common.tokens_transferred": "已转移代币",
  "common.transaction_details": "交易详情",
  "common.transaction_fee": "交易费用",
  "common.transaction_hash": "交易哈希",
  "common.transactions": "交易",
  "common.txn_batch": "交易批次",
  "common.block_height": "区块高度",
  "common.uncle_block": "叔块",
  "common.type_of_transfer": "转账类型",
  "common.user_operations": "用户操作",
  "common.verify_tx_hash": "验证交易哈希",
  "common.view_next_block": "查看下一个区块",
  "common.view_previous_block": "查看上一个区块",
  "common.waiting": "等待中",
  "common.waiting_for_confirmation": "等待确认",
  "common.withdrawal_status": "提款状态",
  "home.average_block_time": "平均出块时间",
  "home.blockchain_explorer": "{network} 区块链浏览器",
  "home.btc_locked_in_2wp": "2WP 中锁定的 BTC",
  "home.current_epoch": "当前 Epoch",
  "home.daily_operational_txs": "每日操作交易",
  "home.daily_operational_txs_hint":
    "昨日 0:00 - 23:59 UTC 的操作交易数量。图表展示过去 30 天的每日操作交易。",
  "home.daily_txs": "每日交易数",
  "home.daily_txs_hint":
    "昨日 0:00 - 23:59 UTC 的交易数量。图表展示过去 30 天的每日交易。",
  "home.deposits_l1_l2_txn": "充值（L1→L2 交易）",
  "home.explorer": "{network} 浏览器",
  "home.finalized_epoch": "已最终确定 Epoch #{epoch}",
  "home.latest_batch": "最新批次",
  "home.latest_batches": "最新批次",
  "home.latest_blocks": "最新区块",
  "home.latest_l1_state_batch": "最新 L1 状态批次",
  "home.latest_transactions": "最新交易",
  "home.latest_txn": "最新交易",
  "home.market_cap": "市值",
  "home.market_cap_hint":
    "加密货币流通供应量的总市场价值。市值 = 当前价格 x 流通供应量。",
  "home.network_utilization": "网络利用率",
  "home.token_price": "{symbol} 价格",
  "home.token_price_hint": "{symbol} 代币每日美元价格。",
  "home.total_blocks": "总区块数",
  "home.total_operational_transactions": "总操作交易数",
  "home.total_transactions": "总交易数",
  "home.transactions": "交易",
  "transactions.avg_transaction_fee": "平均交易手续费",
  "transactions.pending_transactions": "待处理交易",
  "transactions.transaction_fees": "交易手续费",
  "tokens.all": "全部",
  "tokens.bridged": "跨链",
  "tokens.bridged_description": "通过 {bridges} 扩展跨链的代币列表",
  "tokens.crypto_markets": "加密市场",
  "tokens.description_support_info": "描述和支持信息",
  "tokens.empty_filtered": "未找到符合筛选条件的代币。",
  "tokens.filtered_by_owner": "按拥有者筛选",
  "tokens.owner_hint": "此代币实例的当前拥有者",
  "tokens.creator": "创建者",
  "tokens.creator_hint": "部署此代币合约的地址",
  "tokens.token_id_hint": "此代币实例的唯一代币 ID",
  "tokens.transfers_hint": "此代币实例的转账次数",
  "tokens.dapp_hint": "指向 DApp 的链接",
  "tokens.metadata.error_title": "错误",
  "tokens.metadata.refresh_failed": "刷新过程失败，请重试。",
  "tokens.metadata.please_wait": "请稍候",
  "tokens.metadata.refetch_request_sent": "已发送重新获取元数据请求",
  "tokens.metadata.unable_to_initialize": "无法初始化元数据更新",
  "tokens.metadata.success_title": "成功！",
  "tokens.metadata.refreshed": "元数据已刷新",
  "tokens.metadata.sending_request": "正在发送请求",
  "tokens.metadata.recaptcha_missing":
    "当前无法刷新元数据，因为未为此应用程序配置 reCaptcha。请联系服务维护人员以在服务配置中进行必要的更改。",
  "tokens.metadata.refresh": "刷新元数据",
  "tokens.metadata.no_metadata": "此 NFT 暂无元数据",
  "tokens.metadata.refresh_error_title": "哎呀！",
  "tokens.metadata.refresh_error_desc": "我们无法刷新元数据。请立即或稍后重试。",
  "tokens.metadata.table": "表格",
  "tokens.no_holders": "该代币暂无持有人。",
  "tokens.no_owner_tokens": "未找到所选拥有者的代币。",
  "tokens.no_tokens": "暂无代币。",
  "tokens.placeholder": "代币名称或符号",
  "tokens.title": "代币",
  "tokens.title_with_network": "{network} 上的代币",
  "token_transfers.address_filter": "地址",
  "token_transfers.incoming": "转入",
  "token_transfers.no_token_transfers": "暂无代币转账。",
  "token_transfers.outgoing": "转出",
  "token_transfers.title": "代币转账",
  "token_transfer.type.token_minting": "代币铸造",
  "token_transfer.type.token_burning": "代币销毁",
  "token_transfer.type.token_spawning": "代币创建",
  "token_transfer.type.token_transfer": "代币转账",
  "home.tvl": "总锁仓价值",
  "home.tvl_hint": "锁定或质押在链上的数字资产总价值。",
  "home.tx_per_day": "每日交易",
  "home.view_all_batches": "查看全部批次",
  "home.view_all_blocks": "查看全部区块",
  "home.view_all_deposits": "查看全部充值",
  "home.view_all_transactions": "查看全部交易",
  "home.view_all_watch_list_transactions": "查看全部关注列表交易",
  "home.wallet_addresses": "钱包地址",
  "language.english": "English",
  "language.label": "语言",
  "language.simplified_chinese": "简体中文",
  "language.traditional_chinese": "繁體中文",
  "nav.api": "API",
  "nav.api_keys": "API 密钥",
  "nav.advanced_filter": "高级筛选",
  "nav.blocks": "区块",
  "nav.blockchain": "区块链",
  "nav.charts_stats": "图表与统计",
  "nav.brand_name_zh": "保全链",
  "nav.brand_name_en": "VeraXChain",
  "nav.custom_abi": "自定义 ABI",
  "nav.dapps": "DApps",
  "nav.deposits_l1_l2": "充值（L1→L2）",
  "nav.dex_tracker": "DEX 跟踪器",
  "nav.dispute_games": "争议游戏",
  "nav.epochs": "Epochs",
  "nav.gas_tracker": "Gas 跟踪器",
  "nav.internal_transactions": "内部交易",
  "nav.interop_messages": "互操作消息",
  "nav.mud_worlds": "MUD 世界",
  "nav.name_services_lookup": "名称服务查询",
  "nav.operations": "操作",
  "nav.other": "其他",
  "nav.output_roots": "输出根",
  "nav.private_tags": "私有标签",
  "nav.submit_public_tag": "提交公共标签",
  "nav.token_transfers": "代币转账",
  "nav.tokens": "代币",
  "nav.top_accounts": "热门账户",
  "nav.transactions": "交易",
  "nav.txn_batches": "交易批次",
  "nav.txn_withdrawals": "交易提款",
  "nav.user_operations": "用户操作",
  "nav.validators": "验证者",
  "nav.verified_addrs": "已验证地址",
  "nav.verified_contracts": "已验证合约",
  "nav.verify_contract": "验证合约",
  "nav.watch_list": "关注列表",
  "nav.withdrawals": "提款",
  "nav.withdrawals_l2_l1": "提款（L2→L1）",
  "accounts.no_accounts": "暂无账户。",
  "network.chains_list": "链列表",
  "network.menu": "网络菜单",
  "network.mainnets": "主网",
  "network_role.miner": "矿工",
  "network_role.poster": "提交者",
  "network_role.sequencer": "排序器",
  "network_role.validator": "验证者",
  "network.other": "其他",
  "network.testnets": "测试网",
  "network_validation.mined": "已挖出",
  "network_validation.posted": "已提交",
  "network_validation.sequenced": "已排序",
  "network_validation.validated": "已验证",
  "page.block_countdown": "区块倒计时",
  "page.block_countdown.description": "预估区块创建并加入区块链所需的时间。",
  "page.block_countdown.placeholder": "按区块号搜索",
  "page.blob.details": "Blob 详情",
  "page.blocks.all": "全部",
  "page.blocks.forked": "分叉区块",
  "page.blocks.uncles": "叔块",
  "page.advanced_filter.filtered_by": "筛选条件：",
  "page.advanced_filter.no_match": "未找到符合当前筛选条件的结果",
  "page.advanced_filter.reset_filters": "重置筛选",
  "page.api_keys.description":
    "创建 API 密钥以用于你的 RPC 和 EthRPC API 请求。更多信息请参阅 ",
  "page.api_keys.limit_notice":
    "你已添加最大数量的 API 密钥（{limit}）。如需更多密钥，请联系我们。",
  "page.api_docs.blockscout_core_api": "Blockscout 核心 API",
  "page.api_docs.eth_rpc_api_description":
    "除了此处记录的自定义 RPC 端点外，Blockscout 的 ETH RPC API 还支持 3 个与以太坊节点完全一致的方法。更多细节请参阅 Ethereum JSON-RPC Specification。",
  "page.api_docs.name_service_api": "名称服务 API",
  "page.api_docs.rpc_api_description":
    "该 API 适用于将应用从 Etherscan 迁移到 Blockscout 的开发者，以及需要通用 API 和数据支持的应用。它同时支持 GET 和 POST 请求。",
  "page.api_docs.stats_api": "统计 API",
  "page.api_docs.tac_operation_lifecycle_api": "TAC 操作生命周期 API",
  "page.api_docs.title": "API 文档",
  "page.api_docs.title_with_network": "{network} API 文档",
  "page.api_docs.user_ops_indexer_api": "用户操作索引器 API",
  "page.api_docs.swagger.try_it_out": "试一试",
  "page.api_docs.swagger.cancel": "取消",
  "page.api_docs.swagger.execute": "执行",
  "page.api_docs.swagger.clear": "清除",
  "page.api_docs.swagger.parameters": "参数",
  "page.api_docs.swagger.responses": "响应",
  "page.api_docs.swagger.description": "描述",
  "page.api_docs.swagger.name": "名称",
  "page.api_docs.swagger.links": "链接",
  "page.api_docs.swagger.code": "状态码",
  "page.api_docs.swagger.schema": "结构",
  "page.api_docs.swagger.example_value": "示例值",
  "page.api_docs.swagger.media_type": "媒体类型",
  "page.api_docs.swagger.no_links": "无链接",
  "page.api_docs.swagger.request_body": "请求体",
  "page.api_docs.swagger.response_headers": "响应头",
  "page.api_docs.swagger.response_body": "响应体",
  "page.api_docs.swagger.loading": "加载中",
  "page.api_docs.swagger.models": "模型",
  "page.api_docs.swagger.schemas": "结构定义",
  "page.api_docs.swagger.model": "模型",
  "page.api_docs.swagger.show": "显示",
  "page.api_docs.swagger.hide": "隐藏",
  "page.api_docs.swagger.required": "必填",
  "page.api_docs.swagger.available_values": "可用值",
  "page.api_docs.swagger.response_content_type": "响应内容类型",
  "page.api_docs.swagger.parameter_content_type": "参数内容类型",
  "page.api_docs.swagger.apply": "应用",
  "page.api_docs.swagger.close": "关闭",
  "page.api_docs.swagger.download": "下载",
  "page.api_docs.swagger.servers": "服务器",
  "page.api_docs.swagger.authorize": "授权",
  "page.api_docs.swagger.copy": "复制",
  "page.api_docs.swagger.unable_to_render": "无法渲染",
  "page.api_docs.swagger.examples": "示例",
  "page.api_docs.swagger.request_url": "请求 URL",
  "page.api_docs.swagger.server_response": "服务器响应",
  "page.api_docs.swagger.curl": "Curl",
  "page.api_docs.swagger.request_duration": "请求耗时",
  "page.api_docs.swagger.edit_value": "编辑值",
  "page.address.contract_details": "合约详情",
  "page.address.contract_details_on": "{network} 上的合约详情",
  "page.address.details": "地址详情",
  "page.address.details_on": "{network} 上的地址详情",
  "page.address.checking_contract_verification": "正在检查合约验证",
  "page.address.contract_successfully_verified": "合约验证成功",
  "page.address.contract_not_verified_automatically": "合约未自动验证。请手动验证。",
  "page.address.contract_creation_code": "合约创建代码",
  "page.address.contract_selfdestructed_after_deployment":
    "该合约在部署后已自毁，且没有运行时的字节码。以下是原始的创建字节码。",
  "page.address.contract_creation_failed":
    "合约创建失败，且没有运行时的字节码。以下是原始的创建字节码。",
  "page.address.verify_and_publish": "验证并发布",
  "page.address.deployed_bytecode": "已部署的字节码",
  "page.address.click_to_view_qr": "点击查看二维码",
  "page.address.show_qr": "显示二维码",
  "page.address.unable_to_generate_qr": "无法生成二维码。",
  "page.address.address_qr_code": "地址二维码",
  "page.address.token_label": "Token",
  "page.address.token_name": "Token 名称",
  "page.address.token_name_hint": "Token 名称和符号",
  "page.address.contract_name": "合约名称",
  "page.address.contract_name_hint": "在合约源码中找到的名称",
  "page.address.validator_name": "验证者名称",
  "page.address.validator_name_hint": "验证者的名称",
  "page.address.creator": "创建者",
  "page.address.creator_hint": "创建交易和地址",
  "page.address.balance": "余额",
  "page.address.balance_hint": "{unit} 余额",
  "page.address.tokens": "Token",
  "page.address.tokens_hint": "账户中所有 Token 及总价值",
  "page.address.net_worth": "净资产",
  "page.address.net_worth_hint": "该地址所有 Token 以美元计算的总净资产",
  "page.address.transactions": "交易",
  "page.address.transactions_hint": "与该地址相关的交易数量",
  "page.address.transfers": "转账",
  "page.address.transfers_hint": "该地址的转入/转出次数",
  "page.address.gas_used": "已用 Gas",
  "page.address.gas_used_hint": "该地址消耗的 Gas",
  "page.address.last_balance_update": "最后余额更新",
  "page.address.last_balance_update_hint": "该地址最后更新的区块号",
  "page.address.widgets_hint": "由第三方合作伙伴提供的指标",
  "page.address.at_txn": "交易",
  "page.address.filecoin_id": "ID",
  "page.address.filecoin_id_hint": "地址的短标识符，可能随链状态更新而改变",
  "page.address.filecoin_actor": "Actor",
  "page.address.filecoin_actor_hint": "标识地址在 Filecoin 网络上的目的和行为",
  "page.address.filecoin_eth_address": "以太坊地址",
  "page.address.filecoin_eth_address_hint": "Filecoin 地址由以太坊地址管理器分配的 0x 式地址",
  "page.address.outgoing_transactions": "发出交易",
  "page.address.incoming_transactions": "接收交易",
  "page.address.no_internal_txs": "该地址暂无内部交易。",
  "page.address.no_logs": "该地址暂无日志。",
  "page.address.no_coin_balance_history": "该地址暂无原生币余额历史。",
  "page.address.no_tokens_of_type": "暂无所选类型的代币。",
  "page.address.empty_filtered_transactions": "未找到符合查询条件的交易。",
  "page.address.empty_filtered_token_transfers": "未找到符合查询条件的代币转账。",
  "page.address.by_collection": "按合集",
  "page.address.list": "列表",
  "page.address.nfts": "NFT",
  "page.address.view_in_collection": "在合集中查看",
  "page.address.view_all_nfts": "查看全部 NFT",
  "page.address.items_count": "{count} 个",
  "page.address.tokens_count": "{count} 个代币",
  "page.address.delta": "变动",
  "page.address.balances": "余额",
  "page.address.insufficient_chart_data": "过去 {days} 天的数据不足",

  "page.contract_verification.new_title": "新智能合约验证",
  "page.contract_verification.title": "验证并发布合约",

  "contract_verification.address_heading": "要验证的合约地址",
  "contract_verification.address_placeholder": "智能合约 / 地址 (0x...)",
  "contract_verification.license_placeholder": "合约许可证",
  "contract_verification.license_hint":
    "建议所有合约源代码持有者、发布者和作者为其已验证的合约源代码指定相应的许可证。",
  "contract_verification.method_heading": "目前支持 {count} 种合约验证方式",
  "contract_verification.method_heading_tooltip": "目前支持 {count} 种方式：",
  "contract_verification.method_placeholder": "验证方法（编译器类型）",
  "contract_verification.verify_publish": "验证并发布",
  "contract_verification.verify_publish_loading": "验证并发布",
  "contract_verification.success_title": "成功",
  "contract_verification.success_description": "合约验证成功。",
  "contract_verification.error_title": "错误",
  "contract_verification.socket_error": "Socket 连接出错，请稍后重试。",
  "contract_verification.already_verified": "合约已完成验证",
  "contract_verification.not_smart_contract": "该地址不是智能合约",
  "contract_verification.something_wrong": "出现错误",
  "contract_verification.method.flattened_code": "Solidity（单文件）",
  "contract_verification.method.standard_input": "Solidity（标准 JSON 输入）",
  "contract_verification.method.sourcify": "Solidity（Sourcify）",
  "contract_verification.method.multi_part": "Solidity（多文件）",
  "contract_verification.method.vyper_code": "Vyper（合约）",
  "contract_verification.method.vyper_multi_part": "Vyper（多文件）",
  "contract_verification.method.vyper_standard_input": "Vyper（标准 JSON 输入）",
  "contract_verification.method.solidity_hardhat": "Solidity（Hardhat）",
  "contract_verification.method.solidity_foundry": "Solidity（Foundry）",
  "contract_verification.method.stylus_github": "Stylus（GitHub 仓库）",
  "contract_verification.method_hint.flattened_code": "通过单个文件验证。",
  "contract_verification.method_hint.multi_part": "验证多文件 Solidity 合约。",
  "contract_verification.method_hint.sourcify": "通过 Sourcify 验证。",
  "contract_verification.method_hint.standard_input": "使用标准输入 JSON 文件验证。",
  "contract_verification.method_hint.standard_input_link": "标准输入 JSON",
  "contract_verification.method_hint.vyper_code": "验证 Vyper 合约。",
  "contract_verification.method_hint.vyper_multi_part": "验证多文件 Vyper 合约。",
  "contract_verification.method_hint.vyper_standard_input": "使用标准输入 JSON 文件验证 Vyper 合约。",
  "contract_verification.method_hint.vyper_standard_input_link": "标准输入 JSON",
  "contract_verification.method_hint.solidity_hardhat": "通过 Hardhat 插件验证。",
  "contract_verification.method_hint.solidity_foundry": "通过 Foundry 验证。",
  "contract_verification.method_hint.stylus_github": "通过 GitHub 仓库验证 Stylus 合约。",
  "contract_verification.title.flattened_code": "通过 Solidity（扁平化源代码）验证合约",
  "contract_verification.title.standard_input": "通过 Solidity（标准 JSON 输入）验证合约",
  "contract_verification.title.sourcify": "通过 Solidity（Sourcify）验证合约",
  "contract_verification.title.multi_part": "通过 Solidity（多文件）验证合约",
  "contract_verification.title.vyper_code": "通过 Vyper（合约）验证合约",
  "contract_verification.title.vyper_multi_part": "通过 Vyper（多文件）验证合约",
  "contract_verification.title.vyper_standard_input": "通过 Vyper（标准 JSON 输入）验证合约",
  "contract_verification.title.solidity_hardhat": "通过 Solidity Hardhat 插件验证合约",
  "contract_verification.title.solidity_foundry": "通过 Foundry 验证合约",
  "contract_verification.title.stylus_github": "通过 Stylus（GitHub 仓库）验证合约",
  "contract_verification.field.contract_name": "合约名称",
  "contract_verification.field.contract_code": "合约代码",
  "contract_verification.field.compiler": "编译器",
  "contract_verification.field.evm_version": "EVM 版本",
  "contract_verification.field.constructor_args": "ABI 编码的构造函数参数",
  "contract_verification.field.optimization_runs": "优化运行次数",
  "contract_verification.field.library_name": "库名称（.sol 文件）",
  "contract_verification.field.library_address": "库地址 (0x...)",
  "contract_verification.field.library_item_title": "合约库 {index}",
  "contract_verification.hint.library_name": "在 .sol 文件中调用的库名称。每个合约最多可添加 10 个库。",
  "contract_verification.hint.library_address": "库的 0x 地址。可在生成的 json 文件或 Truffle 输出中找到。",
  "contract_verification.field.github_repo_url": "GitHub 仓库 URL",
  "contract_verification.field.commit_hash": "提交哈希",
  "contract_verification.field.path_prefix": "路径前缀",
  "contract_verification.field.zk_compiler": "ZK 编译器",
  "contract_verification.field.optimization_enabled": "启用优化",
  "contract_verification.field.is_yul": "是否为 Yul 合约",
  "contract_verification.field.autodetect_constructor_args": "自动获取构造函数参数",
  "contract_verification.field.add_libraries": "添加合约库",
  "contract_verification.field.standard_input_json": "标准输入 JSON",
  "contract_verification.field.include_nightly": "包含 nightly 构建",
  "contract_verification.hint.compiler_solidity":
    "编译器版本在 pragma solidity X.X.X 中指定。请使用编译器版本而非 nightly 构建。如使用 Solidity 编译器，可运行 solc —version 检查。",
  "contract_verification.hint.constructor_args":
    "如合约需要，请以 ABI 十六进制编码形式添加参数。构造函数参数从右到左写入，位于生成字节码末尾。",
  "contract_verification.hint.evm_version":
    "合约所针对的 EVM 版本。若字节码与版本不匹配，我们将尝试使用最新 EVM 版本验证。",
  "contract_verification.hint.evm_version_link": "EVM 版本详情",
  "contract_verification.hint.zk_compiler": "zksolc 编译器版本。",
  "contract_verification.hint.contract_code_library": "若代码使用了库或继承依赖，建议使用其他验证方式。",
  "contract_verification.hint.contract_name": "必须与代码中指定的名称一致。",
  "contract_verification.hint.contract_name_prefix": "必须与代码中指定的名称一致。例如，在",
  "contract_verification.hint.contract_name_suffix": "是合约名称。",
  "contract_verification.hint.vyper_contract_name": "合约名称是浏览器中为已验证合约分配的名称。",
  "contract_verification.hint.standard_input": "上传合约编译时生成的标准输入 JSON 文件。",
  "contract_verification.hint.multipart_sources": "上传所有 Solidity 或 Yul 合约源文件。",
  "contract_verification.hint.multipart_sources_title": "源文件 *.sol 或 *.yul",
  "contract_verification.hint.sourcify_title": "源文件与元数据 JSON",
  "contract_verification.hint.sourcify": "上传所有 Solidity 合约源文件及编译时生成的 JSON 元数据文件。",
  "contract_verification.hint.vyper_multipart_main_title": "上传主 *.vy 源文件",
  "contract_verification.hint.vyper_multipart_main":
    "主 Vyper 编译合约。仅上传已部署字节码对应的主合约；其他文件请上传至下方接口区域。",
  "contract_verification.hint.vyper_multipart_interfaces_title": "接口（.vy 或 .json）",
  "contract_verification.hint.vyper_multipart_interfaces_prefix": "添加主编译合约所需的",
  "contract_verification.hint.vyper_multipart_interfaces_link": "接口",
  "contract_verification.hint.vyper_multipart_interfaces_suffix": "。",
  "contract_verification.hint.path_prefix": "crate 应位于根目录。如不在根目录，请指定从根目录到 crate 目录的相对路径。",
  "contract_verification.hint.hardhat_tutorial": "Hardhat 合约验证完整教程请见",
  "contract_verification.hint.hardhat_tutorial_link": "此处",
  "contract_verification.hint.foundry_tutorial": "Foundry 合约验证完整教程请见",
  "contract_verification.hint.foundry_tutorial_link": "此处",
  "contract_verification.hint.latest_commit_found": "我们已找到该仓库的最新提交哈希：",
  "contract_verification.hint.click_here": "点击此处",
  "contract_verification.file.drop_file": "拖放文件或点击此处",
  "contract_verification.file.drop_files": "拖放文件或点击此处",
  "contract_verification.file.field_required": "此字段为必填项",
  "contract_verification.file.wrong_file_type": "文件类型错误。允许的类型：{types}。",
  "contract_verification.file.file_too_big": "文件过大。最大大小为 20 Mb。",
  "contract_verification.file.one_file_only": "只能上传一个文件",
  "contract_verification.validation.github_not_found": "未找到 GitHub 仓库",
  "contract_verification.validation.invalid_github_url": "无效的 GitHub 仓库 URL",
  "contract_verification.validation.commit_not_found": "仓库中未找到该提交哈希",

  "page.csv_export.title": "导出数据到 CSV 文件",
  "page.chart.select_resolution": "选择分辨率",
  "page.chart.period": "周期",
  "page.chart.resolution": "分辨率",
  "page.chart.resolution_short": "分辨率",
  "page.chart.menu.share": "分享",
  "page.chart.menu.copy_link": "复制链接",
  "page.chart.menu.view_fullscreen": "全屏查看",
  "page.chart.menu.save_png": "保存为 PNG",
  "page.chart.menu.save_csv": "保存为 CSV",
  "page.chart.menu.options": "打开图表选项菜单",
  "page.stats.title": "{network} 统计",
  "page.stats.title_with_data": "{network} 统计与数据",
  "page.stats.all_stats": "全部统计",
  "page.stats.find_chart": "搜索图表、指标...",
  "page.stats.select_section": "选择分类",
  "page.stats.chart_load_error": "部分图表因服务器未响应而未能加载。如需重新加载图表，请",
  "page.stats.chart_load_error_link": "再次点击。",
  "page.stats.empty_chart": "未找到与您筛选条件匹配的图表。",
  "stats.interval.all": "全部",
  "stats.interval.one_month": "1 个月",
  "stats.interval.three_months": "3 个月",
  "stats.interval.six_months": "6 个月",
  "stats.interval.one_year": "1 年",
  "stats.resolution.day": "日",
  "stats.resolution.week": "周",
  "stats.resolution.month": "月",
  "stats.resolution.year": "年",
  "page.computor_transactions.title": "Computor 交易",
  "page.deposits.no_deposits": "暂无充值。",
  "page.deposits.total_found": "共找到 {count} 笔充值",
  "page.dispute_games.no_dispute_games": "暂无争议游戏。",
  "page.dispute_games.summary":
    "争议游戏索引 #{from} 至 #{to}（共 {count} 个）",
  "page.epochs.no_epochs": "暂无 Epoch。",
  "page.transactions.blob_txns": "Blob 交易",
  "page.transactions.pending": "待处理",
  "page.transactions.title": "交易",
  "page.transactions.title_with_network": "{network} 交易",
  "page.gas_tracker.faq": "常见问题",
  "page.gas_tracker.faq_a1": "Gas 是在区块链上执行交易所需支付的原生代币数量。",
  "page.gas_tracker.faq_a2":
    "你可以通过访问 Gas 跟踪器轻松查看 {network} 的实时 Gas 费用。" +
    "它会显示所有 {network} 交易当前以 {unit} 计价的 Gas 费用。",
  "page.gas_tracker.faq_a3":
    "{network} 交易的平均 Gas 费用取决于网络拥堵程度和交易复杂度。" +
    "Blockscout 提供实时 Gas 费用估算，帮助用户做出判断。",
  "page.gas_tracker.faq_a4":
    "Blockscout 会根据最近 200 个区块中实际花费的 Gas 费用平均价格来计算 Gas 费用。",
  "page.gas_tracker.faq_q1": "区块链中的 Gas 是什么？",
  "page.gas_tracker.faq_q2": "如何查看 {network} Gas 费用？",
  "page.gas_tracker.faq_q3": "{network} 交易的平均 Gas 费用是多少？",
  "page.gas_tracker.faq_q4": "Blockscout 如何计算 Gas 费用？",
  "page.gas_tracker.last_updated": "最后更新",
  "page.gas_tracker.no_recent_data": "暂无最新数据",
  "page.gas_tracker.overview": "Gas 跟踪器概览",
  "page.gas_tracker.price_history": "Gas 价格历史",
  "page.gas_tracker.track_fees": "追踪 {network} Gas 费用",
  "page.gas_tracker.title_with_network": "{network} Gas 跟踪器",
  "page.internal_txs.empty_filtered": "未找到符合查询条件的内部交易。",
  "page.internal_txs.no_internal_txs": "暂无内部交易。",
  "page.internal_txs.placeholder": "按交易哈希搜索",
  "page.interop_messages.no_messages": "暂无互操作消息。",
  "page.interop_messages.total_found": "共找到 {count} 条消息",
  "page.mud_worlds.no_worlds": "暂无 MUD 世界。",
  "page.my_profile.description":
    "你可以添加邮箱以接收关注列表通知。此外，你还可以管理钱包地址和邮箱，它们可用于登录你的 Blockscout 账户。",
  "page.my_profile.title": "我的资料",
  "page.name.details": "名称详情",
  "page.name_domains.empty_filtered": "未找到符合筛选条件的名称域。",
  "page.name_domains.no_domains": "暂无名称域。",
  "page.name_domains.title_with_network": "{network} 名称域",
  "page.operation.details": "操作详情",
  "page.operations.empty_filtered": "未找到符合查询条件的操作。",
  "page.operations.no_operations": "暂无操作。",
  "page.operations.placeholder": "按操作、交易哈希、发送方搜索",
  "page.output_roots.no_output_roots": "暂无输出根。",
  "page.output_roots.summary":
    "L2 输出索引 #{from} 至 #{to}（共 {count} 个根）",
  "page.pools.no_pools": "暂无资金池。",
  "page.pools.empty_filtered": "未找到符合筛选条件的资金池。",
  "page.pools.placeholder": "交易对、代币符号或代币地址",
  "page.pool.lp_token_hint":
    "该流动性提供者（LP）代币代表 {base}/{quote} 交易对。",
  "page.marketplace.placeholder": "按名称或关键词查找应用...",
  "page.search_result.title": "搜索结果",
  "page.search_result.matching_results": "找到 {count}{plus} 条匹配结果：",
  "page.search_results.title": "搜索结果",
  "page.search_results.result_header": "搜索结果",
  "page.sol2uml.title": "Solidity UML 图",
  "page.sol2uml.for_contract": "所属合约",
  "page.txn_batches.no_txn_batches": "暂无交易批次。",
  "page.txn_batches.summary": "交易批次 #{from} 至 #{to}（共 {count} 个批次）",
  "page.txn_withdrawals.empty_filtered": "未找到该交易对应的提款。",
  "page.txn_withdrawals.invalid_tx_hash": "无效的交易哈希",
  "page.txn_withdrawals.relayer_hint":
    "L2 到 L1 消息中继器：搜索你的 L2 交易以执行手动提款。",
  "page.transaction.confidential_compute_tx_details": "机密计算交易详情",
  "page.transaction.details": "交易详情",
  "page.transaction.details_on": "{network} 上的交易详情",
  "page.transaction.regular_tx_details": "常规交易详情",
  "page.transaction_info": "交易信息",
  "page.token.unnamed_token": "未命名代币",
  "page.token.price_hint": "代币在交易所的价格",
  "page.token.market_cap_hint": "流通供应量 × 价格",
  "page.token.max_total_supply_hint": "已发行的代币总量",
  "page.token.holders_hint": "持有该代币的账户数量",
  "page.token.transfers_count_hint": "该代币的转账次数",
  "page.token.decimals_hint": "显示代币数值时小数点后的位数",
  "page.token.marketplaces": "交易市场",
  "page.token.marketplaces_hint": "交易此 NFT 的市场",
  "page.user_op.details": "用户操作详情",
  "page.user_ops.no_user_ops": "暂无用户操作。",
  "page.validator.details": "验证者详情",
  "page.validators.empty_filtered": "未找到符合查询条件的验证者。",
  "page.validators.no_validators": "暂无验证者。",
  "page.verified_contracts.empty_filtered": "未找到符合查询条件的合约。",
  "page.verified_contracts.no_verified_contracts": "暂无已验证合约。",
  "page.verified_contracts.placeholder": "按合约名称或地址搜索",
  "page.verified_contracts.sort_balance_asc": "余额升序",
  "page.verified_contracts.sort_balance_desc": "余额降序",
  "page.verified_contracts.sort_txs_count_asc": "交易数升序",
  "page.verified_contracts.sort_txs_count_desc": "交易数降序",
  "page.verified_contracts.title_with_network": "已验证的 {network} 合约",
  "page.withdrawals.no_withdrawals": "暂无提款。",
  "page.withdrawals.processed_summary":
    "已处理 {count} 笔提款，共提取 {value} {symbol}",
  "page.withdrawals.title_with_network": "{network} 提款",
  "page.withdrawals.total_found": "共找到 {count} 笔提款",
  "page.user_ops.title_with_network": "{network} 用户操作",
  "page.verified_addresses.my_title": "我的已验证地址",
  "page.verified_addresses.back_to_my": "返回我的已验证地址",
  "page.verified_addresses.before_start": "开始前，请确保：",
  "page.verified_addresses.deployed_on": "智能合约源码已部署在“{network}”上。",
  "page.verified_addresses.description":
    "验证智能合约地址的所有权后，你就可以更方便地在 Blockscout 中更新信息。你只需签署一条消息即可验证合约所有权。验证完成后，你可以在 Blockscout 控制台更新代币信息、地址名称标签和地址标签，而无需额外签名。",
  "page.verified_addresses.get_started":
    "完成以上步骤后，点击下方“添加地址”按钮即可开始。",
  "page.verified_addresses.token_info_form": "代币信息申请表",
  "page.verified_addresses.verified_source_code_prefix":
    "源码已验证（如果尚未验证，你可以使用",
  "page.verified_addresses.verified_source_code_suffix": "）。",
  "page.watch_list.description":
    "当你的关注列表中的地址发生任意发送或接收交易时，你可以收到邮件通知。",
  "network.view_all_chains": "查看全部链",
  "search.category.addresses": "地址",
  "search.category.blobs": "Blob 数据",
  "search.category.blocks": "区块",
  "search.category.dapps": "DApps",
  "search.category.names": "名称",
  "search.category.nfts": "NFT（{standard}-721 与 1155）",
  "search.category.operations": "操作",
  "search.category.public_tags": "公共标签",
  "search.category.tokens": "代币（{standard}-20）",
  "search.category.transactions": "交易",
  "search.category.user_operations": "用户操作",
  "search.loading": "正在搜索，请稍候...",
  "search.placeholder_desktop": "按地址 / 交易哈希 / 区块 / 代币搜索... ",
  "search.placeholder_mobile": "按地址 / ... 搜索 ",
  "search.recent": "最近搜索",
  "search.clear_all": "清除全部",
  "settings.color_theme": "颜色主题",
  "settings.show_address_format": "显示 {prefix} 格式",
  "socket.connection_lost_link": "加载更新记录",
  "socket.connection_lost_prefix": "连接已断开，点击",
  "socket.live_updates_delayed": "实时更新暂时延迟",
  "socket.item.block": "区块",
  "socket.item.deposit": "充值",
  "socket.item.token_transfer": "代币转账",
  "socket.item.transaction": "交易",
  "socket.more_items": "新增 {num} 条{name}",
  "socket.scanning_new_items": "正在扫描新的{name}...",
  "home.network_utilization_last_blocks": "网络利用率（最近 {count} 个区块）：",
  "block.reorg_height": "分叉区块高度",
  "block.uncle_height": "叔区块高度",
  "block.genesis_block": " - 创世区块",
  "block.l1_height_hint": "截至此 L2 区块的最新 L1 区块高度",
  "block.batch_hint": "批次号",
  "block.status_hint": "状态是批次生命周期的简短解读",
  "block.miner_hint": "成功将区块包含进区块链的区块生产者",
  "block.commitment_tx_hint": "包含此批次提交的 L1 交易",
  "block.confirmation_tx_hint": "包含此批次确认的 L1 交易",
  "block.reward_hint":
    "对于每个区块，除了为区块中所有交易支付的费用外，{validatorTitle} 还会获得有限数量的 {symbol} 奖励",
  "block.reward_amount_hint":
    "分配的奖励金额。{validatorTitle} 获得静态区块奖励 + 交易费 + 叔区块费",
  "block.static_reward": "静态区块奖励",
  "block.txn_fees": "交易手续费",
  "block.burnt_fees": "销毁费用",
  "block.view_hint": "提议区块的共识轮次迭代",
  "block.gas_used_hint": "区块中使用的 Gas 总量及其在区块中的占比",
  "block.gas_limit_hint": "区块中所有交易提供的总 Gas 限制",
  "block.min_gas_price": "最小 Gas 价格",
  "block.min_gas_price_hint": "交易被包含在此区块中应具有 of 最低 Gas 价格",
  "block.base_fee_per_gas": "每 Gas 基础费用",
  "block.base_fee_per_gas_hint":
    "每单位 Gas 所需的最低费用。费用根据网络拥堵情况进行调整",
  "block.burnt_fees_hint":
    "区块中包含的交易所销毁的 {symbol} 数量。等于区块每 Gas 基础费用 * 已用 Gas",
  "block.burnt_fees_utilization_hint": "销毁费用 / 交易手续费 * 100%",
  "block.priority_fee": "优先费 / 小费",
  "block.priority_fee_hint":
    "发送给验证者以获得交易优先级/包含的用户自定义小费",
  "block.difficulty_hint": "{validatorTitle} 的区块难度，用于校准区块生成时间",
  "block.total_difficulty_hint": "截至此区块的链总难度",
  "block.hash_hint": "区块的 SHA256 哈希值",
  "block.parent_hash_hint": "生成此区块的区块哈希值",
  "block.nonce_hint": "区块随机数是挖矿过程中用于证明区块工作量的值",
  "block.send_count": "发送次数",
  "block.send_count_hint": "截至此区块的 L2 到 L1 交易累计数量",
  "block.send_root": "发送根",
  "block.send_root_hint":
    "代表截至此区块的所有 L2 到 L1 交易的 Merkle 累加器根",
  "block.delayed_messages": "延迟消息",
  "block.delayed_messages_hint": "截至此区块读取的延迟 L1 到 L2 消息数",
  "block.tx_count_label": "{count} 笔交易",
  "block.blob_tx_count_label": "{count} 笔 blob 交易",
  "block.including": "，其中包括",
  "block.in_this_block": "（在此区块中）",
  "block.height_hint": "特定区块的区块高度定义为区块链中排在它前面的区块数量",
  "block.size_hint": "区块的字节大小",
  "block.timestamp_hint": "区块生成的日期和时间。",
  "block.transactions_hint": "区块中包含的交易数量",
  "block.withdrawals_hint": "区块中包含的信标链提现数量",
  "block.difficulty": "难度",
  "block.total_difficulty": "总难度",
  "block.hash": "哈希",
  "block.parent_hash": "父哈希",
  "tx.state.description":
    "当网络上发生交易时，代表当前状态的一组信息将随之更新。以下是这些变化的摘要。",
  "tx.state.empty": "该交易暂无状态变更记录。",
  "tx.state.before_change": "变更前",
  "tx.state.after_change": "变更后",
  "tx.state.change_amount": "变更量",
  "tx.state.mint_address": "铸造地址",
  "tx.state.burn_address": "销毁地址",
  "tx.state.miner_tooltip": "成功将区块包含进入区块链的区块生产者",
  "tx.state.mint_burn_tooltip": "用于代币铸造和销毁操作的地址",
  "tx.raw_trace.empty": "未找到追踪条目。",
  "tx.logs.empty": "该交易暂无日志记录。",
  "tx.blobs.empty": "该交易暂无 Blob 数据。",
  "tx.blobs.blob_hash": "Blob 哈希",
  "tx.blobs.data_type": "数据类型",
  "tx.internals.empty": "该交易暂无内部交易记录。",
  "tx.internals.gas_limit": "Gas 限制",
  "tx.internal.type.call": "调用",
  "tx.internal.type.delegatecall": "委托调用",
  "tx.internal.type.staticcall": "静态调用",
  "tx.internal.type.create": "创建",
  "tx.internal.type.create2": "Create2",
  "tx.internal.type.selfdestruct": "自毁",
  "tx.internal.type.reward": "奖励",
  "tx.token_transfers.empty": "该交易暂无代币转账记录。",
  "tx.token_transfers.empty_filtered": "未找到符合条件的代币转账记录。",
  "tx.type.contract_call": "合约调用",
  "tx.type.blob_transaction": "Blob 交易",
  "tx.type.token_transfer": "代币转账",
  "tx.type.token_creation": "代币创建",
  "tx.type.rootstock_remasc": "REMASC",
  "tx.type.rootstock_bridge": "跨链桥",
  "tx.type.transaction": "交易",
  "tx.asset_flows.wallet": "钱包",
  "tx.asset_flows.actions": "操作",
  "tx.asset_flows.empty": "该交易暂无转账记录。",
  "tx.authorizations.empty": "该交易暂无授权记录。",
  "tx.authorizations.authority": "授权方",
  "tx.authorizations.chain": "链",
  "tx.authorizations.chain_this": "本链",
  "tx.authorizations.chain_any": "任意链",
  "common.additional_info": "附加信息",
  "common.txn_type": "交易类型",
  "common.more_details": "更多详情",
  "tx.hint.transaction_hash": "分配给每个已验证交易的唯一字符序列（交易 ID/TxID）",
  "tx.hint.status": "当前交易状态：成功、失败（错误）或挂起（处理中）",
  "tx.hint.status_details": "交易的详细状态进度",
  "tx.hint.l1_status": "交易确认到 L1 的路径状态",
  "tx.hint.revert_reason": "交易的回退原因",
  "tx.hint.batch_lifecycle": "状态是批次生命周期的简短说明",
  "tx.hint.block": "包含该交易的区块号",
  "tx.hint.batch_index": "此交易的批次索引",
  "tx.hint.batch_number": "批次号",
  "tx.hint.batch_index_in_block": "包含此交易的批次索引",
  "tx.hint.timestamp": "包含该交易的日期和时间，以及确认所需的时间长度",
  "tx.hint.confidential_node": "执行机密计算的节点",
  "tx.hint.from": "发送交易的地址（外部地址或合约）",
  "tx.hint.to": "接收交易的地址（外部地址或合约）",
  "tx.hint.interop_target": "执行此跨链交易的目标地址",
  "tx.hint.commitment_tx": "包含此批次承诺的 L1 交易",
  "tx.hint.confirmation_tx": "包含此批次确认 of L1 交易",
  "tx.hint.value": "以原生代币发送的价值（及相应的美元价值，如果适用）",
  "tx.hint.fee": "总交易费用",
  "tx.hint.fee_without_blob": "不包含 Blob 费用的交易费用",
  "tx.hint.poster_fee": "为 L1 资源支付给提交者的费用",
  "tx.hint.execution_fee": "为 L2 资源支付给网络的费用",
  "tx.hint.gas_used": "交易实际使用的 Gas 量",
  "tx.hint.l1_data_gas": "预留用于 L1 数据费用的 L2 Gas",
  "tx.hint.l2_gas_used": "在 L2 资源上消耗 the L2 Gas",
  "tx.hint.l1_gas_used": "在 L1 上使用的总 Gas",
  "tx.hint.l1_gas_used_by_txn": "交易使用的 L1 Gas",
  "tx.hint.l1_gas_price": "L1 Gas 价格",
  "tx.hint.l1_data_fee": "L1 数据费，用于支付来自批次提交机制的 L1“安全”成本。结合 L2 执行费，L1 费用构成了交易支付的总费用。",
  "tx.hint.l1_fee_scalar": "动态开销（费用系数）溢价，作为 L1 价格快速上涨时的缓冲。",
  "tx.hint.gas_fees_breakdown": "基础费用是指区块发布时网络的 Base Fee，而最大费用和最大优先级费用分别是指用户愿意为其交易支付的最大金额以及给予 {validatorTitle} 的最大金额",
  "tx.hint.blob_fee": "此交易的 Blob 费用",
  "tx.hint.blob_gas_used": "此交易中 Blob 使用的 Gas 量",
  "tx.hint.blob_eth_used": "此交易中用于 Blob 的 {symbol} 数量",
  "tx.hint.input_data": "交易中包含的二进制数据。有关附加信息，请参见日志选项卡",
  "tx.hint.gas_limit": "交易可使用最大 Gas 量",
  "block.merged_mining.bitcoin_header": "比特币合并挖矿区块头",
  "block.merged_mining.coinbase_txn": "比特币合并挖矿Coinbase交易",
  "block.merged_mining.merkle_proof": "比特币合并挖矿默克尔证明",
  "block.merged_mining.rootstock_hash": "合并挖矿哈希",
  "block.celo_base_fee.handler_label": "基础费用处理器",
  "block.celo_base_fee.handler_hint": "接收基础费用的合约，负责处理费用使用。该合约由治理程序控制。",
  "block.celo_base_fee.total_label": "基础费用总计",
  "block.celo_base_fee.total_hint_prefix": "FeeHandler定期销毁80%的代币。非CELO代币会事先兑换为CELO。其余的20%将发送到",
  "block.celo_base_fee.total_hint_suffix": "。",
  "block.celo_base_fee.burnt": "已销毁",
  "block.celo_base_fee.percentage_of_amount": "金额的 {percentage}%",
  "block.blob_info.price_label": "Blob Gas 价格",
  "block.blob_info.price_hint": "用于Blob部署的每单位Gas的价格。Blob Gas独立于普通Gas。两种Gas价格都可能影响交易执行的优先级。",
  "block.blob_info.used_label": "已使用的 Blob Gas",
  "block.blob_info.used_hint": "本区块中Blob实际使用的Gas量",
  "block.blob_info.burnt_label": "Blob销毁费用",
  "block.blob_info.burnt_hint": "本区块中用于Blob的 {symbol} 数量",
  "block.blob_info.utilization_tooltip": "Blob销毁费用 / 交易费用 * 100%",
  "block.blob_info.excess_label": "多余的 Blob Gas",
  "block.blob_info.excess_hint": "在本区块之前，消耗的超过目标的Blob Gas的累计总量。",
  "block.zilliqa_qc.consensus_explanation": "提出区块的共识轮次的迭代：",
  "block.zilliqa_qc.view_explanation": "View — 法定人数证书的视图编号，指示共识轮次。",
  "block.zilliqa_qc.signature_explanation": "Signature — 代表验证者协议的聚合BLS签名。",
  "block.zilliqa_qc.signers_explanation": "Signers — 代表参与法定人数的验证者索引的整数数组（由联合签名的位向量指示）。",
  "block.zilliqa_qc.proposed_explanation": "Proposed by validator — 提出嵌套法定人数证书的验证者索引。",
  "block.zilliqa_qc.aggregate_quorum_certificate": "聚合法定人数证书",
  "block.zilliqa_qc.quorum_certificate": "法定人数证书",
  "block.zilliqa_qc.view": "视图",
  "block.zilliqa_qc.signature": "签名",
  "block.zilliqa_qc.signers": "签名者",
  "block.zilliqa_qc.nested_quorum_certificates": "嵌套法定人数证书",
  "block.zilliqa_qc.proposed_by_validator": "验证者提议",
  "tx.allowed_peekers.label": "允许的查看器",
  "tx.allowed_peekers.hint": "允许与机密数据进行交互的智能合约",
  "tx.scroll_fees.l1_fee_hint": "用于支付Rollup成本的L1费用",
  "tx.scroll_fees.l2_fee_hint": "L2执行费",
  "tx.scroll_fees.scalar_hint": "提交系数",
  "tx.scroll_fees.overhead_hint": "数据提交交易的额外Gas开销",
  "tx.scroll_fees.l1_gas_fees_hint": "L1 Gas费用",
  "tx.scroll_fees.l1_blob_fees_hint": "L1 Blob费用",
  "tx.fee_per_gas.hint": "每单位Gas的费用",
  "tx.interop.source_txn_hint": "在源链上发起跨L2消息的原始交易",
  "tx.interop.relay_txn_hint": "将跨L2消息转发到目标链的交易",
  "tx.withdrawal_status_arbitrum.status_hint": "交易的详细状态进度",
  "tx.withdrawal_status_arbitrum.origin_txn_hint": "从基础层发起消息的交易的哈希",
  "tx.gas_price.hint": "发送方指定的每单位Gas的价格。在网络使用率高时，较高的Gas价格可以优先处理交易。",
  "tx.other.hint": "与此交易相关的其他数据",
  "blob.info.not_indexed": "此Blob尚未被索引",
  "blob.info.proof_label": "证明",
  "blob.info.proof_hint": "零知识证明，允许快速验证承诺",
  "blob.info.commitment_label": "承诺",
  "blob.info.commitment_hint": "对Blob中数据的承诺",
  "blob.info.size_label": "大小，字节",
  "blob.info.size_hint": "Blob的字节大小",
  "blob.info.txn_hash_label": "交易哈希",
  "blob.info.txn_hash_hint": "包含此Blob的交易哈希",
  "blob.data.not_an_image": "不是图像",
  "blob.data.title": "Blob 数据",
  "blob.data.select_type": "选择类型",
  "blob.data.download": "下载",
  "blob.data.format.image": "图像",
  "blob.data.format.raw": "原始数据",
  "blob.data.format.utf8": "UTF-8",
  "blob.data.format.base64": "Base64",
  "common.originating_l1_txn_hash": "发起 L1 交易哈希",
  "tx.hint.decoded_input_data": "已解码的输入数据",
  "tx.hint.method": "交易方法名称",
  "stats.chart.incomplete_resolution": "未完成的{resolution}",
  "stats.tooltip.date": "日期",
  "stats.tooltip.dates": "日期范围",
  "stats.tooltip.month": "月份",
  "stats.tooltip.year": "年份",
  "stats.tooltip.value": "数值",
  "stats.counter.averageBlockTime.title": "平均出块时间",
  "stats.counter.averageBlockTime.description": "区块纳入区块链所需的平均时间（秒）",
  "stats.counter.completedTxns.title": "已完成交易",
  "stats.counter.completedTxns.description": "成功状态的交易数量",
  "stats.counter.lastNewContracts.title": "今日新增合约",
  "stats.counter.lastNewContracts.description": "今日（UTC）部署的合约数量",
  "stats.counter.lastNewVerifiedContracts.title": "今日已验证合约",
  "stats.counter.lastNewVerifiedContracts.description": "今日（UTC）验证的合约数量",
  "stats.counter.totalAccounts.title": "总账户数",
  "stats.counter.totalAccounts.description": "至少发送过 1 笔交易的外部账户（EOA）数量",
  "stats.counter.totalAddresses.title": "总地址数",
  "stats.counter.totalAddresses.description": "参与链上活动的地址数量",
  "stats.counter.totalBlocks.title": "总区块数",
  "stats.counter.totalBlocks.description": "全时段区块数量",
  "stats.counter.totalContracts.title": "总合约数",
  "stats.counter.totalContracts.description": "合约数量",
  "stats.counter.totalNativeCoinTransfers.title": "总 ETH 转账",
  "stats.counter.totalNativeCoinTransfers.description": "包含 ETH 转账的交易数量",
  "stats.counter.totalTokens.title": "总代币数",
  "stats.counter.totalTokens.description": "所有代币合约数量",
  "stats.counter.totalTxns.title": "总交易数",
  "stats.counter.totalTxns.description": "包括待处理、丢弃、替换、失败在内的全部交易",
  "stats.counter.totalVerifiedContracts.title": "总已验证合约",
  "stats.counter.totalVerifiedContracts.description": "已验证合约数量",
  "stats.counter.newTxns24h.title": "24 小时交易数",
  "stats.counter.newTxns24h.description": "过去 24 小时内的新交易数量",
  "stats.counter.pendingTxns30m.title": "30 分钟内待处理交易",
  "stats.counter.pendingTxns30m.description": "过去 30 分钟内等待网络处理的交易",
  "stats.counter.txnsFee24h.title": "24 小时交易费",
  "stats.counter.txnsFee24h.description": "过去 24 小时内消耗的 ETH gas 费用总和",
  "stats.counter.averageTxnFee24h.title": "24 小时平均交易费",
  "stats.counter.averageTxnFee24h.description": "过去 24 小时内每笔交易平均消耗的 ETH gas 费用",
  "stats.section.accounts.title": "账户",
  "stats.section.transactions.title": "交易",
  "stats.section.blocks.title": "区块",
  "stats.section.tokens.title": "代币",
  "stats.section.gas.title": "Gas",
  "stats.section.contracts.title": "合约",
  "stats.section.user_ops.title": "用户操作",
  "stats.chart.accountsGrowth.title": "账户数量",
  "stats.chart.accountsGrowth.description": "账户累计增长趋势",
  "stats.chart.activeAccounts.title": "活跃账户",
  "stats.chart.activeAccounts.description": "各周期活跃账户数量",
  "stats.chart.newAccounts.title": "新增账户",
  "stats.chart.newAccounts.description": "新增加的账户数量",
  "stats.chart.averageTxnFee.title": "平均交易费",
  "stats.chart.averageTxnFee.description": "每笔交易平均消耗的 ETH gas 费用",
  "stats.chart.newTxns.title": "新增交易",
  "stats.chart.newTxns.description": "新增交易数量",
  "stats.chart.txnsFee.title": "交易费",
  "stats.chart.txnsFee.description": "消耗的 ETH gas 费用总和",
  "stats.chart.txnsGrowth.title": "交易数量",
  "stats.chart.txnsGrowth.description": "交易累计增长趋势",
  "stats.chart.txnsSuccessRate.title": "交易成功率",
  "stats.chart.txnsSuccessRate.description": "所有已包含交易的成功率",
  "stats.chart.averageBlockRewards.title": "平均区块奖励",
  "stats.chart.averageBlockRewards.description": "平均奖励数量",
  "stats.chart.averageBlockSize.title": "平均区块大小",
  "stats.chart.averageBlockSize.description": "区块各字段占用的空间（字节）",
  "stats.chart.newBlocks.title": "新增区块",
  "stats.chart.newBlocks.description": "链上新增区块数量",
  "stats.chart.newNativeCoinTransfers.title": "ETH 转账数量",
  "stats.chart.newNativeCoinTransfers.description": "已完成的代币转账",
  "stats.chart.averageGasLimit.title": "平均 Gas 上限",
  "stats.chart.averageGasLimit.description": "平均区块 Gas 上限",
  "stats.chart.averageGasPrice.title": "平均 Gas 价格",
  "stats.chart.averageGasPrice.description": "每单位 Gas 的平均价格（Gwei）",
  "stats.chart.gasUsedGrowth.title": "Gas 总用量",
  "stats.chart.gasUsedGrowth.description": "Gas 累计使用量",
  "stats.chart.networkUtilization.title": "网络利用率",
  "stats.chart.networkUtilization.description": "Gas 使用量占 Gas 上限的百分比",
  "stats.chart.averageGasUsed.title": "平均 Gas 用量",
  "stats.chart.averageGasUsed.description": "每个区块平均使用的 Gas 数量",
  "stats.chart.contractsGrowth.title": "合约数量",
  "stats.chart.contractsGrowth.description": "合约累计增长趋势",
  "stats.chart.newContracts.title": "新增合约",
  "stats.chart.newContracts.description": "网络中新增合约数量",
  "stats.chart.newVerifiedContracts.title": "新增已验证合约",
  "stats.chart.newVerifiedContracts.description": "新验证的合约数量",
  "stats.chart.verifiedContractsGrowth.title": "已验证合约数量",
  "stats.chart.verifiedContractsGrowth.description": "已验证合约累计增长趋势",
};

const zhTW: Record<TranslationKey, string> = {
  "app_error.403.text": "存取該資源受限。",
  "app_error.403.title": "提醒",
  "app_error.404.text": "該頁面已無法瀏覽。你可以使用搜尋列查找所需內容。",
  "app_error.404.title": "頁面未找到",
  "app_error.422.text":
    "請求中包含錯誤，可能是交易、區塊或地址雜湊輸入有誤。請檢查後重試。",
  "app_error.422.title": "請求無法處理",
  "app_error.500.text": "發生了意外錯誤。請重新載入頁面，或稍後再試。",
  "app_error.500.title": "糟糕，發生問題了",
  "common.age": "時間",
  "common.add_address": "新增地址",
  "common.add_api_key": "新增 API 金鑰",
  "common.add_token_to_wallet": "新增代幣到{wallet}",
  "common.apple": "Apple",
  "common.all": "全部",
  "common.address": "地址",
  "common.api_documentation_unavailable": "暫無 API 文件",
  "common.back_to_home": "返回首頁",
  "common.balance": "餘額",
  "common.balance_with_symbol": "餘額 {symbol}",
  "common.base_fee": "基礎費用",
  "common.block": "區塊",
  "common.block_confirmations": "{count} 個區塊確認",
  "common.burnt_fees": "銷毀費用",
  "common.bytes": "位元組",
  "common.call": "調用",
  "common.batch": "批次",
  "common.category": "分類",
  "common.constructor_args": "建構參數",
  "common.contract": "合約",
  "common.contract_address": "合約地址",
  "common.copy": "複製",
  "common.copy_link_to_clipboard": "複製連結到剪貼簿",
  "common.copy_to_clipboard": "複製到剪貼簿",
  "common.copied": "已複製",
  "common.current_block": "目前區塊",
  "common.default": "預設",
  "common.details": "詳情",
  "common.documentation": "文件",
  "common.error.try_refresh": "發生了一些問題。請重新整理頁面，或稍後再試。",
  "common.estimated_target_date": "預估目標日期",
  "common.fast": "快速",
  "common.fee": "手續費",
  "common.filter": "篩選",
  "common.first": "首頁",
  "common.from": "來自",
  "common.from_to": "從/到",
  "common.gas_used": "Gas 使用量",
  "common.google": "Google",
  "common.hide": "隱藏",
  "common.hide_details": "隱藏詳情",
  "common.hide_scam_tokens": "隱藏風險代幣",
  "common.history": "歷史",
  "common.how_to_use_blockscout_api_key": "如何使用 Blockscout API 金鑰",
  "common.hex": "十六進位",
  "common.info": "資訊",
  "common.inventory": "庫存",
  "common.l1_txn": "L1 交易",
  "common.l1_txn_hash": "L1 交易雜湊",
  "common.l2_txn": "L2 交易",
  "common.l2_txn_hash": "L2 交易雜湊",
  "common.l2_block_no": "L2 區塊號",
  "common.language": "語言",
  "common.language_compiler_version": "語言 / 編譯器版本",
  "common.last_update": "最後更新",
  "common.left": "剩餘",
  "common.links": "連結",
  "common.load_high": "高負載",
  "common.load_low": "低負載",
  "common.load_medium": "中等負載",
  "common.license": "授權",
  "common.logs": "日誌",
  "common.lookup_related_domains": "查找相關域名",
  "common.loading": "資料載入中，請稍候...",
  "common.need_help_contact_admin": "需要幫助？請聯絡管理員團隊：",
  "common.normal": "普通",
  "common.no_data": "暫無資料，請重新整理頁面。",
  "common.no_data_selected_interval": "所選解析度與時間區間暫無資料。",
  "common.no_data_short": "暫無資料",
  "common.no_blocks": "暫無區塊。",
  "common.no_results": "暫無結果",
  "common.no_results_found": "未找到結果。",
  "common.no_transactions": "暫無交易。",
  "common.holder": "持有人",
  "common.holders": "持有人",
  "common.id_short": "ID#",
  "common.index": "索引",
  "common.on_chain_market_cap": "鏈上市值",
  "common.owner": "擁有者",
  "common.optimization": "最佳化",
  "common.parent_txn_hash": "父交易雜湊",
  "common.per_transaction": "每筆交易",
  "common.percentage": "占比",
  "common.pending_claim": "待領取",
  "common.prev_page": "上一頁",
  "common.next_page": "下一頁",
  "common.price": "價格",
  "common.priority": "優先費",
  "common.quantity": "數量",
  "common.rank": "排名",
  "common.raw": "原始資料",
  "common.remaining_blocks": "剩餘區塊",
  "common.reset": "重置",
  "common.reset_zoom": "重置縮放",
  "common.reward": "獎勵",
  "common.sender": "發送方",
  "common.select_chain": "選擇鏈",
  "common.select_interval": "選擇時間區間",
  "common.select_type": "選擇類型",
  "common.settings": "設定",
  "common.size": "大小",
  "common.size_bytes": "大小，位元組",
  "common.slow": "慢速",
  "common.show_info": "顯示資訊",
  "common.status": "狀態",
  "common.success": "成功",
  "common.failed": "失敗",
  "common.pending": "待處理",
  "common.timestamp": "時間戳",
  "common.time_left": "剩餘時間",
  "common.this_tool": "這個工具",
  "common.to": "到",
  "common.testnet_transaction_only": "這是一筆僅限測試網的交易",
  "common.toggle_time_format": "切換時間格式",
  "common.total_contracts": "合約總數",
  "common.transfers": "轉帳",
  "common.txn": "交易",
  "common.txn_count": "交易數",
  "common.txn_hash": "交易雜湊",
  "common.tx_hash": "交易雜湊",
  "common.txs": "交易",
  "common.type": "類型",
  "common.utf8": "UTF-8",
  "common.method": "方法",
  "common.method_id": "方法 ID",
  "common.msg_nonce": "訊息 nonce",
  "common.name": "名稱",
  "common.token": "代幣",
  "common.token_id": "代幣 ID",
  "common.user_op_hash": "使用者操作雜湊",
  "common.user": "使用者",
  "common.validator_index": "驗證者索引",
  "common.value": "數值",
  "common.view_all": "查看全部",
  "common.view_details": "查看詳情",
  "common.view_all_results": "查看全部結果",
  "common.verified": "已驗證",
  "common.verified_contracts": "已驗證合約",
  "common.verify_with": "驗證源",
  "common.verify_with_other_explorers": "使用其他瀏覽器驗證",
  "common.website_settings": "網站設定",
  "common.widgets": "元件",
  "common.zk_compiler": "ZK 編譯器",
  "common.for_assistance": " 以取得協助！",
  "common.account_history": "帳戶歷史",
  "common.address_from": "發送地址",
  "common.address_to": "接收地址",
  "common.amount": "數量",
  "common.amount_from": "數量起始值",
  "common.amount_to": "數量結束值",
  "common.and_or": "與/或",
  "common.api_documentation": "API 文件",
  "common.asset": "資產",
  "common.asset_flows": "資產流向",
  "common.authorizations": "授權",
  "common.base": "基礎",
  "common.blob_fee": "Blob 費用",
  "common.blob_gas_fees": "Blob Gas 費用",
  "common.blob_gas_usage": "Blob Gas 使用量",
  "common.blobs": "Blobs",
  "common.code": "程式碼",
  "common.coin_transfer": "原生幣轉帳",
  "common.coin_balance_history": "原生幣餘額歷史",
  "common.columns": "欄位",
  "common.commitment_tx": "提交交易",
  "common.confirmation_status": "確認狀態",
  "common.confirmation_tx": "確認交易",
  "common.contract_creation": "合約建立",
  "common.confirmed_within": "在 {lower} 秒內確認",
  "common.confirmed_within_lte": "在 <= {upper} 秒內確認",
  "common.confirmed_within_range": "在 {lower} - {upper} 秒內確認",
  "common.date_from": "開始日期",
  "common.date_to": "結束日期",
  "common.data": "資料",
  "common.decimals": "小數位",
  "common.decoded_input_data": "已解碼輸入資料",
  "common.dapp": "DApp",
  "common.epoch_rewards": "Epoch 獎勵",
  "common.eth_rpc_api": "ETH RPC API",
  "common.exclude": "排除",
  "common.find_by_function_name_method_id": "按函式名稱/方法 ID 查找",
  "common.finalized": "已最終確認",
  "common.gas_fees": "Gas 費用",
  "common.gas_limit": "Gas 上限",
  "common.gas_price": "Gas 價格",
  "common.gas_used_for_l1": "用於 L1 的 Gas",
  "common.gas_used_for_l2": "用於 L2 的 Gas",
  "common.gas_usage_and_limit_by_txn": "交易 Gas 使用量與上限",
  "common.graphql_api": "GraphQL API",
  "common.include": "包含",
  "common.indexed": "已索引?",
  "common.incoming_message": "傳入訊息",
  "common.interacted_with_contract": "與合約互動",
  "common.internal_txns": "內部交易",
  "common.interop_target": "互操作目標",
  "common.kettle": "Kettle",
  "common.l1_fee": "L1 費用",
  "common.l1_fee_scalar": "L1 費用係數",
  "common.l1_gas_price": "L1 Gas 價格",
  "common.l1_gas_used": "L1 Gas 使用量",
  "common.l1_gas_used_by_txn": "交易使用的 L1 Gas",
  "common.l1_status": "L1 狀態",
  "common.l2_status_and_method": "L2 狀態與方法",
  "common.market_cap": "市值",
  "common.max": "最大",
  "common.max_priority": "最大優先費",
  "common.max_total_supply": "最大總供應量",
  "common.metadata": "中繼資料",
  "common.network_fee": "網路費用",
  "common.no_tokens_found": "未找到代幣",
  "common.nonce": "Nonce",
  "common.outgoing_message": "傳出訊息",
  "common.popular": "熱門",
  "common.poster_fee": "發布者費用",
  "common.raw_input": "原始輸入",
  "common.raw_trace": "原始追蹤",
  "common.revert_reason": "回退原因",
  "common.rest_api": "REST API",
  "common.rpc_api_endpoints": "RPC API 端點",
  "common.select_mode": "選擇模式",
  "common.sequence_tx_hash": "排序交易雜湊",
  "common.smart_contract_or_address": "智慧合約 / 地址 (0x...)*",
  "common.show_all": "顯示全部",
  "common.syncing_with_base_layer": "與基礎層同步中",
  "common.state": "狀態",
  "common.status_and_method": "狀態與方法",
  "common.validated_by": "驗證者",
  "common.contract_execution_completed": "合約執行完成",
  "common.contract_execution_error": "合約執行過程中發生錯誤",
  "common.contract_execution_status": "合約執行狀態",
  "common.could_not_determine": "無法確定",
  "common.execution_fee": "執行費用",
  "common.blocks_mined": "已挖出區塊",
  "common.blocks_posted": "已提交區塊",
  "common.blocks_sequenced": "已排序區塊",
  "common.blocks_validated": "已驗證區塊",
  "common.interop_relay_tx": "互操作中繼交易",
  "common.interop_source_tx": "互操作來源交易",
  "common.interop_status": "互操作狀態",
  "common.l1_commit_scalar": "L1 提交係數",
  "common.l1_block_height": "L1 區塊高度",
  "common.l1_blob_fees": "L1 Blob 費用",
  "common.l1_data_fee": "L1 資料費用",
  "common.l1_fee_overhead": "L1 費用開銷",
  "common.l1_gas_fees": "L1 Gas 費用",
  "common.message_id": "訊息 ID",
  "common.mined_by": "出塊者",
  "common.other": "其他",
  "common.payload": "負載",
  "common.position": "位置",
  "common.posted_by": "提交者",
  "common.queue_index": "佇列索引",
  "common.ready_for_relay": "可中繼",
  "common.relayed": "已中繼",
  "common.reorged_block": "重組區塊",
  "common.scalar": "係數",
  "common.sequenced_by": "排序者",
  "common.settlement_pending": "結算待處理",
  "common.target": "目標",
  "common.tokens_burnt": "已銷毀代幣",
  "common.tokens_created": "已建立代幣",
  "common.tokens_minted": "已鑄造代幣",
  "common.tokens_transferred": "已轉移代幣",
  "common.transaction_details": "交易詳情",
  "common.transaction_fee": "交易費用",
  "common.transaction_hash": "交易雜湊",
  "common.transactions": "交易",
  "common.txn_batch": "交易批次",
  "common.block_height": "區塊高度",
  "common.uncle_block": "叔塊",
  "common.type_of_transfer": "轉帳類型",
  "common.user_operations": "使用者操作",
  "common.verify_tx_hash": "驗證交易雜湊",
  "common.view_next_block": "查看下一個區塊",
  "common.view_previous_block": "查看上一個區塊",
  "common.waiting": "等待中",
  "common.waiting_for_confirmation": "等待確認",
  "common.withdrawal_status": "提款狀態",
  "home.average_block_time": "平均出塊時間",
  "home.blockchain_explorer": "{network} 區塊鏈瀏覽器",
  "home.btc_locked_in_2wp": "2WP 中鎖定的 BTC",
  "home.current_epoch": "目前 Epoch",
  "home.daily_operational_txs": "每日操作交易",
  "home.daily_operational_txs_hint":
    "昨日 0:00 - 23:59 UTC 的操作交易數量。圖表展示過去 30 天的每日操作交易。",
  "home.daily_txs": "每日交易數",
  "home.daily_txs_hint":
    "昨日 0:00 - 23:59 UTC 的交易數量。圖表展示過去 30 天的每日交易。",
  "home.deposits_l1_l2_txn": "充值（L1→L2 交易）",
  "home.explorer": "{network} 瀏覽器",
  "home.finalized_epoch": "已最終確定 Epoch #{epoch}",
  "home.latest_batch": "最新批次",
  "home.latest_batches": "最新批次",
  "home.latest_blocks": "最新區塊",
  "home.latest_l1_state_batch": "最新 L1 狀態批次",
  "home.latest_transactions": "最新交易",
  "home.latest_txn": "最新交易",
  "home.market_cap": "市值",
  "home.market_cap_hint":
    "加密貨幣流通供應量的總市場價值。市值 = 目前價格 x 流通供應量。",
  "home.network_utilization": "網路利用率",
  "home.token_price": "{symbol} 價格",
  "home.token_price_hint": "{symbol} 代幣每日美元價格。",
  "home.total_blocks": "總區塊數",
  "home.total_operational_transactions": "總操作交易數",
  "home.total_transactions": "總交易數",
  "home.transactions": "交易",
  "transactions.avg_transaction_fee": "平均交易手續費",
  "transactions.pending_transactions": "待處理交易",
  "transactions.transaction_fees": "交易手續費",
  "tokens.all": "全部",
  "tokens.bridged": "跨鏈",
  "tokens.bridged_description": "透過 {bridges} 擴展跨鏈的代幣列表",
  "tokens.crypto_markets": "加密市場",
  "tokens.description_support_info": "描述和支援資訊",
  "tokens.empty_filtered": "未找到符合篩選條件的代幣。",
  "tokens.filtered_by_owner": "按擁有者篩選",
  "tokens.owner_hint": "此代幣實例的當前擁有者",
  "tokens.creator": "建立者",
  "tokens.creator_hint": "部署此代幣合約的地址",
  "tokens.token_id_hint": "此代幣實例的唯一代幣 ID",
  "tokens.transfers_hint": "此代幣實例的轉帳次數",
  "tokens.dapp_hint": "指向 DApp 的連結",
  "tokens.metadata.error_title": "錯誤",
  "tokens.metadata.refresh_failed": "刷新過程失敗，請重試。",
  "tokens.metadata.please_wait": "請稍候",
  "tokens.metadata.refetch_request_sent": "已發送重新獲取元數據請求",
  "tokens.metadata.unable_to_initialize": "無法初始化元數據更新",
  "tokens.metadata.success_title": "成功！",
  "tokens.metadata.refreshed": "元數據已刷新",
  "tokens.metadata.sending_request": "正在發送請求",
  "tokens.metadata.recaptcha_missing":
    "當前無法刷新元數據，因為未為此應用程式配置 reCaptcha。請聯絡服務維護人員以在服務配置中進行必要的更改。",
  "tokens.metadata.refresh": "刷新元數據",
  "tokens.metadata.no_metadata": "此 NFT 暫無元數據",
  "tokens.metadata.refresh_error_title": "哎呀！",
  "tokens.metadata.refresh_error_desc": "我們無法刷新元數據。請立即或稍後重試。",
  "tokens.metadata.table": "表格",
  "tokens.no_holders": "該代幣暫無持有人。",
  "tokens.no_owner_tokens": "未找到所選擁有者的代幣。",
  "tokens.no_tokens": "暫無代幣。",
  "tokens.placeholder": "代幣名稱或符號",
  "tokens.title": "代幣",
  "tokens.title_with_network": "{network} 上的代幣",
  "token_transfers.address_filter": "地址",
  "token_transfers.incoming": "轉入",
  "token_transfers.no_token_transfers": "暫無代幣轉帳。",
  "token_transfers.outgoing": "轉出",
  "token_transfers.title": "代幣轉帳",
  "token_transfer.type.token_minting": "代幣鑄造",
  "token_transfer.type.token_burning": "代幣銷毀",
  "token_transfer.type.token_spawning": "代幣建立",
  "token_transfer.type.token_transfer": "代幣轉帳",
  "home.tvl": "總鎖倉價值",
  "home.tvl_hint": "鎖定或質押在鏈上的數位資產總價值。",
  "home.tx_per_day": "每日交易",
  "home.view_all_batches": "查看全部批次",
  "home.view_all_blocks": "查看全部區塊",
  "home.view_all_deposits": "查看全部充值",
  "home.view_all_transactions": "查看全部交易",
  "home.view_all_watch_list_transactions": "查看全部關注清單交易",
  "home.wallet_addresses": "錢包地址",
  "language.english": "English",
  "language.label": "語言",
  "language.simplified_chinese": "简体中文",
  "language.traditional_chinese": "繁體中文",
  "nav.api": "API",
  "nav.api_keys": "API 金鑰",
  "nav.advanced_filter": "進階篩選",
  "nav.blocks": "區塊",
  "nav.blockchain": "區塊鏈",
  "nav.charts_stats": "圖表與統計",
  "nav.brand_name_zh": "保全鏈",
  "nav.brand_name_en": "VeraXChain",
  "nav.custom_abi": "自訂 ABI",
  "nav.dapps": "DApps",
  "nav.deposits_l1_l2": "充值（L1→L2）",
  "nav.dex_tracker": "DEX 追蹤器",
  "nav.dispute_games": "爭議遊戲",
  "nav.epochs": "Epochs",
  "nav.gas_tracker": "Gas 追蹤器",
  "nav.internal_transactions": "內部交易",
  "nav.interop_messages": "互操作訊息",
  "nav.mud_worlds": "MUD 世界",
  "nav.name_services_lookup": "名稱服務查詢",
  "nav.operations": "操作",
  "nav.other": "其他",
  "nav.output_roots": "輸出根",
  "nav.private_tags": "私有標籤",
  "nav.submit_public_tag": "提交公共標籤",
  "nav.token_transfers": "代幣轉帳",
  "nav.tokens": "代幣",
  "nav.top_accounts": "熱門帳戶",
  "nav.transactions": "交易",
  "nav.txn_batches": "交易批次",
  "nav.txn_withdrawals": "交易提款",
  "nav.user_operations": "使用者操作",
  "nav.validators": "驗證者",
  "nav.verified_addrs": "已驗證地址",
  "nav.verified_contracts": "已驗證合約",
  "nav.verify_contract": "驗證合約",
  "nav.watch_list": "關注清單",
  "nav.withdrawals": "提款",
  "nav.withdrawals_l2_l1": "提款（L2→L1）",
  "accounts.no_accounts": "暫無帳戶。",
  "network.chains_list": "鏈列表",
  "network.menu": "網路選單",
  "network.mainnets": "主網",
  "network_role.miner": "礦工",
  "network_role.poster": "提交者",
  "network_role.sequencer": "排序器",
  "network_role.validator": "驗證者",
  "network.other": "其他",
  "network.testnets": "測試網",
  "network_validation.mined": "已挖出",
  "network_validation.posted": "已提交",
  "network_validation.sequenced": "已排序",
  "network_validation.validated": "已驗證",
  "page.block_countdown": "區塊倒數",
  "page.block_countdown.description": "預估區塊建立並加入區塊鏈所需的時間。",
  "page.block_countdown.placeholder": "按區塊號搜尋",
  "page.blob.details": "Blob 詳情",
  "page.blocks.all": "全部",
  "page.blocks.forked": "分叉區塊",
  "page.blocks.uncles": "叔塊",
  "page.advanced_filter.filtered_by": "篩選條件：",
  "page.advanced_filter.no_match": "未找到符合目前篩選條件的結果",
  "page.advanced_filter.reset_filters": "重置篩選",
  "page.api_keys.description":
    "建立 API 金鑰以用於你的 RPC 與 EthRPC API 請求。更多資訊請參閱 ",
  "page.api_keys.limit_notice":
    "你已新增最大數量的 API 金鑰（{limit}）。如需更多金鑰，請聯絡我們。",
  "page.api_docs.blockscout_core_api": "Blockscout 核心 API",
  "page.api_docs.eth_rpc_api_description":
    "除了此處記錄的自訂 RPC 端點外，Blockscout 的 ETH RPC API 還支援 3 個與以太坊節點完全一致的方法。更多細節請參閱 Ethereum JSON-RPC Specification。",
  "page.api_docs.name_service_api": "名稱服務 API",
  "page.api_docs.rpc_api_description":
    "此 API 適用於將應用從 Etherscan 遷移到 Blockscout 的開發者，以及需要通用 API 和資料支援的應用。它同時支援 GET 和 POST 請求。",
  "page.api_docs.stats_api": "統計 API",
  "page.api_docs.tac_operation_lifecycle_api": "TAC 操作生命週期 API",
  "page.api_docs.title": "API 文件",
  "page.api_docs.title_with_network": "{network} API 文件",
  "page.api_docs.user_ops_indexer_api": "使用者操作索引器 API",
  "page.api_docs.swagger.try_it_out": "試一試",
  "page.api_docs.swagger.cancel": "取消",
  "page.api_docs.swagger.execute": "執行",
  "page.api_docs.swagger.clear": "清除",
  "page.api_docs.swagger.parameters": "參數",
  "page.api_docs.swagger.responses": "回應",
  "page.api_docs.swagger.description": "描述",
  "page.api_docs.swagger.name": "名稱",
  "page.api_docs.swagger.links": "連結",
  "page.api_docs.swagger.code": "狀態碼",
  "page.api_docs.swagger.schema": "結構",
  "page.api_docs.swagger.example_value": "範例值",
  "page.api_docs.swagger.media_type": "媒體類型",
  "page.api_docs.swagger.no_links": "無連結",
  "page.api_docs.swagger.request_body": "請求主體",
  "page.api_docs.swagger.response_headers": "回應標頭",
  "page.api_docs.swagger.response_body": "回應主體",
  "page.api_docs.swagger.loading": "載入中",
  "page.api_docs.swagger.models": "模型",
  "page.api_docs.swagger.schemas": "結構定義",
  "page.api_docs.swagger.model": "模型",
  "page.api_docs.swagger.show": "顯示",
  "page.api_docs.swagger.hide": "隱藏",
  "page.api_docs.swagger.required": "必填",
  "page.api_docs.swagger.available_values": "可用值",
  "page.api_docs.swagger.response_content_type": "回應內容類型",
  "page.api_docs.swagger.parameter_content_type": "參數內容類型",
  "page.api_docs.swagger.apply": "套用",
  "page.api_docs.swagger.close": "關閉",
  "page.api_docs.swagger.download": "下載",
  "page.api_docs.swagger.servers": "伺服器",
  "page.api_docs.swagger.authorize": "授權",
  "page.api_docs.swagger.copy": "複製",
  "page.api_docs.swagger.unable_to_render": "無法渲染",
  "page.api_docs.swagger.examples": "範例",
  "page.api_docs.swagger.request_url": "請求 URL",
  "page.api_docs.swagger.server_response": "伺服器回應",
  "page.api_docs.swagger.curl": "Curl",
  "page.api_docs.swagger.request_duration": "請求耗時",
  "page.api_docs.swagger.edit_value": "編輯值",
  "page.address.contract_details": "合約詳情",
  "page.address.contract_details_on": "{network} 上的合約詳情",
  "page.address.details": "地址詳情",
  "page.address.details_on": "{network} 上的地址詳情",
  "page.address.checking_contract_verification": "正在檢查合約驗證",
  "page.address.contract_successfully_verified": "合約驗證成功",
  "page.address.contract_not_verified_automatically": "合約未自動驗證。請手動驗證。",
  "page.address.contract_creation_code": "合約建立代碼",
  "page.address.contract_selfdestructed_after_deployment":
    "該合約在部署後已自毀，且沒有運作時的位元組碼。以下是原始的建立位元組碼。",
  "page.address.contract_creation_failed":
    "合約建立失敗，且沒有運作時的位元組碼。以下是原始的建立位元組碼。",
  "page.address.verify_and_publish": "驗證並發布",
  "page.address.deployed_bytecode": "已部署的位元組碼",
  "page.address.click_to_view_qr": "點擊查看二維碼",
  "page.address.show_qr": "顯示二維碼",
  "page.address.unable_to_generate_qr": "無法生成二維碼。",
  "page.address.address_qr_code": "地址二維碼",
  "page.address.token_label": "Token",
  "page.address.token_name": "Token 名稱",
  "page.address.token_name_hint": "Token 名稱和符號",
  "page.address.contract_name": "合約名稱",
  "page.address.contract_name_hint": "在合約原始碼中找到的名稱",
  "page.address.validator_name": "驗證者名稱",
  "page.address.validator_name_hint": "驗證者的名稱",
  "page.address.creator": "建立者",
  "page.address.creator_hint": "建立交易和地址",
  "page.address.balance": "餘額",
  "page.address.balance_hint": "{unit} 餘額",
  "page.address.tokens": "Token",
  "page.address.tokens_hint": "帳戶中所有 Token 及總價值",
  "page.address.net_worth": "淨資產",
  "page.address.net_worth_hint": "該地址所有 Token 以美元計算的總淨資產",
  "page.address.transactions": "交易",
  "page.address.transactions_hint": "與該地址相關的交易數量",
  "page.address.transfers": "轉帳",
  "page.address.transfers_hint": "該地址的轉入/轉出次數",
  "page.address.gas_used": "已用 Gas",
  "page.address.gas_used_hint": "該地址消耗的 Gas",
  "page.address.last_balance_update": "最後餘額更新",
  "page.address.last_balance_update_hint": "該地址最後更新的區塊編號",
  "page.address.widgets_hint": "由第三方合作廥伴提供的指標",
  "page.address.at_txn": "交易",
  "page.address.filecoin_id": "ID",
  "page.address.filecoin_id_hint": "地址的短標識符，可能隨鏈狀態更新而改變",
  "page.address.filecoin_actor": "Actor",
  "page.address.filecoin_actor_hint": "標識地址在 Filecoin 網路上的目的和行為",
  "page.address.filecoin_eth_address": "以太坊地址",
  "page.address.filecoin_eth_address_hint": "Filecoin 地址由以太坊地址管理器分配的 0x 式地址",
  "page.address.outgoing_transactions": "發出交易",
  "page.address.incoming_transactions": "接收交易",
  "page.address.no_internal_txs": "該地址暫無內部交易。",
  "page.address.no_logs": "該地址暫無日誌。",
  "page.address.no_coin_balance_history": "該地址暫無原生幣餘額歷史。",
  "page.address.no_tokens_of_type": "暫無所選類型的代幣。",
  "page.address.empty_filtered_transactions": "未找到符合查詢條件的交易。",
  "page.address.empty_filtered_token_transfers": "未找到符合查詢條件的代幣轉帳。",
  "page.address.by_collection": "按合集",
  "page.address.list": "列表",
  "page.address.nfts": "NFT",
  "page.address.view_in_collection": "在合集中查看",
  "page.address.view_all_nfts": "查看全部 NFT",
  "page.address.items_count": "{count} 個",
  "page.address.tokens_count": "{count} 個代幣",
  "page.address.delta": "變動",
  "page.address.balances": "餘額",
  "page.address.insufficient_chart_data": "過去 {days} 天的資料不足",

  "page.contract_verification.new_title": "新智慧合約驗證",
  "page.contract_verification.title": "驗證並發布合約",

  "contract_verification.address_heading": "要驗證的合約地址",
  "contract_verification.address_placeholder": "智慧合約 / 地址 (0x...)",
  "contract_verification.license_placeholder": "合約授權",
  "contract_verification.license_hint":
    "建議所有合約原始碼持有者、發布者和作者為其已驗證的合約原始碼指定相應的授權條款。",
  "contract_verification.method_heading": "目前支援 {count} 種合約驗證方式",
  "contract_verification.method_heading_tooltip": "目前支援 {count} 種方式：",
  "contract_verification.method_placeholder": "驗證方法（編譯器類型）",
  "contract_verification.verify_publish": "驗證並發布",
  "contract_verification.verify_publish_loading": "驗證並發布",
  "contract_verification.success_title": "成功",
  "contract_verification.success_description": "合約驗證成功。",
  "contract_verification.error_title": "錯誤",
  "contract_verification.socket_error": "Socket 連線出錯，請稍後重試。",
  "contract_verification.already_verified": "合約已完成驗證",
  "contract_verification.not_smart_contract": "該地址不是智慧合約",
  "contract_verification.something_wrong": "發生錯誤",
  "contract_verification.method.flattened_code": "Solidity（單檔案）",
  "contract_verification.method.standard_input": "Solidity（標準 JSON 輸入）",
  "contract_verification.method.sourcify": "Solidity（Sourcify）",
  "contract_verification.method.multi_part": "Solidity（多檔案）",
  "contract_verification.method.vyper_code": "Vyper（合約）",
  "contract_verification.method.vyper_multi_part": "Vyper（多檔案）",
  "contract_verification.method.vyper_standard_input": "Vyper（標準 JSON 輸入）",
  "contract_verification.method.solidity_hardhat": "Solidity（Hardhat）",
  "contract_verification.method.solidity_foundry": "Solidity（Foundry）",
  "contract_verification.method.stylus_github": "Stylus（GitHub 儲存庫）",
  "contract_verification.method_hint.flattened_code": "透過單一檔案驗證。",
  "contract_verification.method_hint.multi_part": "驗證多檔案 Solidity 合約。",
  "contract_verification.method_hint.sourcify": "透過 Sourcify 驗證。",
  "contract_verification.method_hint.standard_input": "使用標準輸入 JSON 檔案驗證。",
  "contract_verification.method_hint.standard_input_link": "標準輸入 JSON",
  "contract_verification.method_hint.vyper_code": "驗證 Vyper 合約。",
  "contract_verification.method_hint.vyper_multi_part": "驗證多檔案 Vyper 合約。",
  "contract_verification.method_hint.vyper_standard_input": "使用標準輸入 JSON 檔案驗證 Vyper 合約。",
  "contract_verification.method_hint.vyper_standard_input_link": "標準輸入 JSON",
  "contract_verification.method_hint.solidity_hardhat": "透過 Hardhat 外掛驗證。",
  "contract_verification.method_hint.solidity_foundry": "透過 Foundry 驗證。",
  "contract_verification.method_hint.stylus_github": "透過 GitHub 儲存庫驗證 Stylus 合約。",
  "contract_verification.title.flattened_code": "透過 Solidity（扁平化原始碼）驗證合約",
  "contract_verification.title.standard_input": "透過 Solidity（標準 JSON 輸入）驗證合約",
  "contract_verification.title.sourcify": "透過 Solidity（Sourcify）驗證合約",
  "contract_verification.title.multi_part": "透過 Solidity（多檔案）驗證合約",
  "contract_verification.title.vyper_code": "透過 Vyper（合約）驗證合約",
  "contract_verification.title.vyper_multi_part": "透過 Vyper（多檔案）驗證合約",
  "contract_verification.title.vyper_standard_input": "透過 Vyper（標準 JSON 輸入）驗證合約",
  "contract_verification.title.solidity_hardhat": "透過 Solidity Hardhat 外掛驗證合約",
  "contract_verification.title.solidity_foundry": "透過 Foundry 驗證合約",
  "contract_verification.title.stylus_github": "透過 Stylus（GitHub 儲存庫）驗證合約",
  "contract_verification.field.contract_name": "合約名稱",
  "contract_verification.field.contract_code": "合約程式碼",
  "contract_verification.field.compiler": "編譯器",
  "contract_verification.field.evm_version": "EVM 版本",
  "contract_verification.field.constructor_args": "ABI 編碼的建構函式參數",
  "contract_verification.field.optimization_runs": "最佳化執行次數",
  "contract_verification.field.library_name": "程式庫名稱（.sol 檔案）",
  "contract_verification.field.library_address": "程式庫地址 (0x...)",
  "contract_verification.field.library_item_title": "合約程式庫 {index}",
  "contract_verification.hint.library_name": "在 .sol 檔案中呼叫的程式庫名稱。每個合約最多可新增 10 個程式庫。",
  "contract_verification.hint.library_address": "程式庫的 0x 地址。可在產生的 json 檔案或 Truffle 輸出中找到。",
  "contract_verification.field.github_repo_url": "GitHub 儲存庫 URL",
  "contract_verification.field.commit_hash": "提交雜湊",
  "contract_verification.field.path_prefix": "路徑前綴",
  "contract_verification.field.zk_compiler": "ZK 編譯器",
  "contract_verification.field.optimization_enabled": "啟用最佳化",
  "contract_verification.field.is_yul": "是否為 Yul 合約",
  "contract_verification.field.autodetect_constructor_args": "自動取得建構函式參數",
  "contract_verification.field.add_libraries": "新增合約程式庫",
  "contract_verification.field.standard_input_json": "標準輸入 JSON",
  "contract_verification.field.include_nightly": "包含 nightly 建置",
  "contract_verification.hint.compiler_solidity":
    "編譯器版本在 pragma solidity X.X.X 中指定。請使用編譯器版本而非 nightly 建置。如使用 Solidity 編譯器，可執行 solc —version 檢查。",
  "contract_verification.hint.constructor_args":
    "如合約需要，請以 ABI 十六進位編碼形式新增參數。建構函式參數從右到左寫入，位於產生位元組碼末尾。",
  "contract_verification.hint.evm_version":
    "合約所針對的 EVM 版本。若位元組碼與版本不符，我們將嘗試使用最新 EVM 版本驗證。",
  "contract_verification.hint.evm_version_link": "EVM 版本詳情",
  "contract_verification.hint.zk_compiler": "zksolc 編譯器版本。",
  "contract_verification.hint.contract_code_library": "若程式碼使用了程式庫或繼承依賴，建議使用其他驗證方式。",
  "contract_verification.hint.contract_name": "必須與程式碼中指定的名稱一致。",
  "contract_verification.hint.contract_name_prefix": "必須與程式碼中指定的名稱一致。例如，在",
  "contract_verification.hint.contract_name_suffix": "是合約名稱。",
  "contract_verification.hint.vyper_contract_name": "合約名稱是瀏覽器中為已驗證合約分配的名稱。",
  "contract_verification.hint.standard_input": "上傳合約編譯時產生的標準輸入 JSON 檔案。",
  "contract_verification.hint.multipart_sources": "上傳所有 Solidity 或 Yul 合約原始碼檔案。",
  "contract_verification.hint.multipart_sources_title": "原始碼 *.sol 或 *.yul",
  "contract_verification.hint.sourcify_title": "原始碼與中繼資料 JSON",
  "contract_verification.hint.sourcify": "上傳所有 Solidity 合約原始碼及編譯時產生的 JSON 中繼資料檔案。",
  "contract_verification.hint.vyper_multipart_main_title": "上傳主 *.vy 原始碼",
  "contract_verification.hint.vyper_multipart_main":
    "主 Vyper 編譯合約。僅上傳已部署位元組碼對應的主合約；其他檔案請上傳至下方介面區域。",
  "contract_verification.hint.vyper_multipart_interfaces_title": "介面（.vy 或 .json）",
  "contract_verification.hint.vyper_multipart_interfaces_prefix": "新增主編譯合約所需的",
  "contract_verification.hint.vyper_multipart_interfaces_link": "介面",
  "contract_verification.hint.vyper_multipart_interfaces_suffix": "。",
  "contract_verification.hint.path_prefix": "crate 應位於根目錄。如不在根目錄，請指定從根目錄到 crate 目錄的相對路徑。",
  "contract_verification.hint.hardhat_tutorial": "Hardhat 合約驗證完整教學請見",
  "contract_verification.hint.hardhat_tutorial_link": "此處",
  "contract_verification.hint.foundry_tutorial": "Foundry 合約驗證完整教學請見",
  "contract_verification.hint.foundry_tutorial_link": "此處",
  "contract_verification.hint.latest_commit_found": "我們已找到該儲存庫的最新提交雜湊：",
  "contract_verification.hint.click_here": "點擊此處",
  "contract_verification.file.drop_file": "拖放檔案或點擊此處",
  "contract_verification.file.drop_files": "拖放檔案或點擊此處",
  "contract_verification.file.field_required": "此欄位為必填",
  "contract_verification.file.wrong_file_type": "檔案類型錯誤。允許的類型：{types}。",
  "contract_verification.file.file_too_big": "檔案過大。最大大小為 20 Mb。",
  "contract_verification.file.one_file_only": "只能上傳一個檔案",
  "contract_verification.validation.github_not_found": "未找到 GitHub 儲存庫",
  "contract_verification.validation.invalid_github_url": "無效的 GitHub 儲存庫 URL",
  "contract_verification.validation.commit_not_found": "儲存庫中未找到該提交雜湊",

  "page.csv_export.title": "匯出資料到 CSV 檔案",
  "page.chart.select_resolution": "選擇解析度",
  "page.chart.period": "週期",
  "page.chart.resolution": "解析度",
  "page.chart.resolution_short": "解析度",
  "page.chart.menu.share": "分享",
  "page.chart.menu.copy_link": "複製連結",
  "page.chart.menu.view_fullscreen": "全螢幕檢視",
  "page.chart.menu.save_png": "儲存為 PNG",
  "page.chart.menu.save_csv": "儲存為 CSV",
  "page.chart.menu.options": "開啟圖表選項選單",
  "page.stats.title": "{network} 統計",
  "page.stats.title_with_data": "{network} 統計與資料",
  "page.stats.all_stats": "全部統計",
  "page.stats.find_chart": "搜尋圖表、指標...",
  "page.stats.select_section": "選擇分類",
  "page.stats.chart_load_error": "部分圖表因伺服器未回應而未能載入。如需重新載入圖表，請",
  "page.stats.chart_load_error_link": "再次點擊。",
  "page.stats.empty_chart": "未找到與您篩選條件相符的圖表。",
  "stats.interval.all": "全部",
  "stats.interval.one_month": "1 個月",
  "stats.interval.three_months": "3 個月",
  "stats.interval.six_months": "6 個月",
  "stats.interval.one_year": "1 年",
  "stats.resolution.day": "日",
  "stats.resolution.week": "週",
  "stats.resolution.month": "月",
  "stats.resolution.year": "年",
  "page.computor_transactions.title": "Computor 交易",
  "page.deposits.no_deposits": "暫無充值。",
  "page.deposits.total_found": "共找到 {count} 筆充值",
  "page.dispute_games.no_dispute_games": "暫無爭議遊戲。",
  "page.dispute_games.summary":
    "爭議遊戲索引 #{from} 至 #{to}（共 {count} 個）",
  "page.epochs.no_epochs": "暫無 Epoch。",
  "page.transactions.blob_txns": "Blob 交易",
  "page.transactions.pending": "待處理",
  "page.transactions.title": "交易",
  "page.transactions.title_with_network": "{network} 交易",
  "page.gas_tracker.faq": "常見問題",
  "page.gas_tracker.faq_a1": "Gas 是在區塊鏈上執行交易所需支付的原生代幣數量。",
  "page.gas_tracker.faq_a2":
    "你可以透過造訪 Gas 追蹤器輕鬆查看 {network} 的即時 Gas 費用。" +
    "它會顯示所有 {network} 交易目前以 {unit} 計價的 Gas 費用。",
  "page.gas_tracker.faq_a3":
    "{network} 交易的平均 Gas 費用取決於網路壅塞程度和交易複雜度。" +
    "Blockscout 提供即時 Gas 費用估算，協助使用者做出判斷。",
  "page.gas_tracker.faq_a4":
    "Blockscout 會根據最近 200 個區塊中實際花費的 Gas 費用平均價格來計算 Gas 費用。",
  "page.gas_tracker.faq_q1": "區塊鏈中的 Gas 是什麼？",
  "page.gas_tracker.faq_q2": "如何查看 {network} Gas 費用？",
  "page.gas_tracker.faq_q3": "{network} 交易的平均 Gas 費用是多少？",
  "page.gas_tracker.faq_q4": "Blockscout 如何計算 Gas 費用？",
  "page.gas_tracker.last_updated": "最後更新",
  "page.gas_tracker.no_recent_data": "暫無最新資料",
  "page.gas_tracker.overview": "Gas 追蹤器概覽",
  "page.gas_tracker.price_history": "Gas 價格歷史",
  "page.gas_tracker.track_fees": "追蹤 {network} Gas 費用",
  "page.gas_tracker.title_with_network": "{network} Gas 追蹤器",
  "page.internal_txs.empty_filtered": "未找到符合查詢條件的內部交易。",
  "page.internal_txs.no_internal_txs": "暫無內部交易。",
  "page.internal_txs.placeholder": "按交易雜湊搜尋",
  "page.interop_messages.no_messages": "暫無互操作訊息。",
  "page.interop_messages.total_found": "共找到 {count} 筆訊息",
  "page.mud_worlds.no_worlds": "暫無 MUD 世界。",
  "page.my_profile.description":
    "你可以新增電子郵件以接收關注清單通知。此外，你還可以管理錢包地址與電子郵件，它們可用於登入你的 Blockscout 帳戶。",
  "page.my_profile.title": "我的資料",
  "page.name.details": "名稱詳情",
  "page.name_domains.empty_filtered": "未找到符合篩選條件的名稱域。",
  "page.name_domains.no_domains": "暫無名稱域。",
  "page.name_domains.title_with_network": "{network} 名稱域",
  "page.operation.details": "操作詳情",
  "page.operations.empty_filtered": "未找到符合查詢條件的操作。",
  "page.operations.no_operations": "暫無操作。",
  "page.operations.placeholder": "按操作、交易雜湊、發送方搜尋",
  "page.output_roots.no_output_roots": "暫無輸出根。",
  "page.output_roots.summary":
    "L2 輸出索引 #{from} 至 #{to}（共 {count} 個根）",
  "page.pools.no_pools": "暫無資金池。",
  "page.pools.empty_filtered": "未找到符合篩選條件的資金池。",
  "page.pools.placeholder": "交易對、代幣符號或代幣地址",
  "page.pool.lp_token_hint":
    "該流動性提供者（LP）代幣代表 {base}/{quote} 交易對。",
  "page.marketplace.placeholder": "按名稱或關鍵字查找應用...",
  "page.search_result.title": "搜尋結果",
  "page.search_result.matching_results": "找到 {count}{plus} 筆匹配結果：",
  "page.search_results.title": "搜尋結果",
  "page.search_results.result_header": "搜尋結果",
  "page.sol2uml.title": "Solidity UML 圖",
  "page.sol2uml.for_contract": "所屬合約",
  "page.txn_batches.no_txn_batches": "暫無交易批次。",
  "page.txn_batches.summary": "交易批次 #{from} 至 #{to}（共 {count} 個批次）",
  "page.txn_withdrawals.empty_filtered": "未找到該交易對應的提款。",
  "page.txn_withdrawals.invalid_tx_hash": "無效的交易雜湊",
  "page.txn_withdrawals.relayer_hint":
    "L2 到 L1 訊息中繼器：搜尋你的 L2 交易以執行手動提款。",
  "page.transaction.confidential_compute_tx_details": "機密計算交易詳情",
  "page.transaction.details": "交易詳情",
  "page.transaction.details_on": "{network} 上的交易詳情",
  "page.transaction.regular_tx_details": "一般交易詳情",
  "page.transaction_info": "交易資訊",
  "page.token.unnamed_token": "未命名代幣",
  "page.token.price_hint": "代幣在交易所的價格",
  "page.token.market_cap_hint": "流通供應量 × 價格",
  "page.token.max_total_supply_hint": "已發行的代幣總量",
  "page.token.holders_hint": "持有該代幣的帳戶數量",
  "page.token.transfers_count_hint": "該代幣的轉帳次數",
  "page.token.decimals_hint": "顯示代幣數值時小數點後的位數",
  "page.token.marketplaces": "交易市場",
  "page.token.marketplaces_hint": "交易此 NFT 的市場",
  "page.user_op.details": "使用者操作詳情",
  "page.user_ops.no_user_ops": "暫無使用者操作。",
  "page.validator.details": "驗證者詳情",
  "page.validators.empty_filtered": "未找到符合查詢條件的驗證者。",
  "page.validators.no_validators": "暫無驗證者。",
  "page.verified_contracts.empty_filtered": "未找到符合查詢條件的合約。",
  "page.verified_contracts.no_verified_contracts": "暫無已驗證合約。",
  "page.verified_contracts.placeholder": "按合約名稱或地址搜尋",
  "page.verified_contracts.sort_balance_asc": "餘額升序",
  "page.verified_contracts.sort_balance_desc": "餘額降序",
  "page.verified_contracts.sort_txs_count_asc": "交易數升序",
  "page.verified_contracts.sort_txs_count_desc": "交易數降序",
  "page.verified_contracts.title_with_network": "已驗證的 {network} 合約",
  "page.withdrawals.no_withdrawals": "暫無提款。",
  "page.withdrawals.processed_summary":
    "已處理 {count} 筆提款，共提取 {value} {symbol}",
  "page.withdrawals.title_with_network": "{network} 提款",
  "page.withdrawals.total_found": "共找到 {count} 筆提款",
  "page.user_ops.title_with_network": "{network} 使用者操作",
  "page.verified_addresses.my_title": "我的已驗證地址",
  "page.verified_addresses.back_to_my": "返回我的已驗證地址",
  "page.verified_addresses.before_start": "開始前，請確認：",
  "page.verified_addresses.deployed_on":
    "智慧合約原始碼已部署在「{network}」上。",
  "page.verified_addresses.description":
    "驗證智慧合約地址的所有權後，你就可以更方便地在 Blockscout 中更新資訊。你只需簽署一則訊息即可驗證合約所有權。驗證完成後，你可以在 Blockscout 控制台更新代幣資訊、地址名稱標籤與地址標籤，而無需額外簽名。",
  "page.verified_addresses.get_started":
    "完成以上步驟後，點擊下方「新增地址」按鈕即可開始。",
  "page.verified_addresses.token_info_form": "代幣資訊申請表",
  "page.verified_addresses.verified_source_code_prefix":
    "原始碼已驗證（若尚未驗證，你可以使用",
  "page.verified_addresses.verified_source_code_suffix": "）。",
  "page.watch_list.description":
    "當你的關注清單中的地址有任何發送或接收交易時，你可以收到電子郵件通知。",
  "network.view_all_chains": "查看全部鏈",
  "search.category.addresses": "地址",
  "search.category.blobs": "Blob 資料",
  "search.category.blocks": "區塊",
  "search.category.dapps": "DApps",
  "search.category.names": "名稱",
  "search.category.nfts": "NFT（{standard}-721 與 1155）",
  "search.category.operations": "操作",
  "search.category.public_tags": "公共標籤",
  "search.category.tokens": "代幣（{standard}-20）",
  "search.category.transactions": "交易",
  "search.category.user_operations": "使用者操作",
  "search.loading": "正在搜尋，請稍候...",
  "search.placeholder_desktop": "按地址 / 交易雜湊 / 區塊 / 代幣搜尋... ",
  "search.placeholder_mobile": "按地址 / ... 搜尋 ",
  "search.recent": "最近搜尋",
  "search.clear_all": "清除全部",
  "settings.color_theme": "顏色主題",
  "settings.show_address_format": "顯示 {prefix} 格式",
  "socket.connection_lost_link": "載入更新記錄",
  "socket.connection_lost_prefix": "連線已中斷，點擊",
  "socket.live_updates_delayed": "即時更新暫時延遲",
  "socket.item.block": "區塊",
  "socket.item.deposit": "充值",
  "socket.item.token_transfer": "代幣轉帳",
  "socket.item.transaction": "交易",
  "socket.more_items": "新增 {num} 筆{name}",
  "socket.scanning_new_items": "正在掃描新的{name}...",
  "home.network_utilization_last_blocks": "網路利用率（最近 {count} 個區塊）：",
  "block.reorg_height": "分叉區塊高度",
  "block.uncle_height": "叔區塊高度",
  "block.genesis_block": " - 創世區塊",
  "block.l1_height_hint": "截至此 L2 區塊的最新 L1 區塊高度",
  "block.batch_hint": "批次號",
  "block.status_hint": "狀態是批次生命週期的簡短解讀",
  "block.miner_hint": "成功將區塊包含進區塊鏈的區塊生產者",
  "block.commitment_tx_hint": "包含此批次提交的 L1 交易",
  "block.confirmation_tx_hint": "包含此批次確認的 L1 交易",
  "block.reward_hint":
    "對於每個區塊，除了為區塊中所有交易支付的費用外，{validatorTitle} 還會獲得有限數量的 {symbol} 獎勵",
  "block.reward_amount_hint":
    "分配的獎勵金額。{validatorTitle} 獲得靜態區塊獎勵 + 交易費 + 叔區塊費",
  "block.static_reward": "靜態區塊獎勵",
  "block.txn_fees": "交易手續費",
  "block.burnt_fees": "銷毀費用",
  "block.view_hint": "提議區塊的共識輪次迭代",
  "block.gas_used_hint": "區塊中使用的 Gas 總量及其在區塊中的占比",
  "block.gas_limit_hint": "區塊中所有交易提供的總 Gas 限制",
  "block.min_gas_price": "最小 Gas 價格",
  "block.min_gas_price_hint": "交易被包含在此區塊中應具有的最低 Gas 價格",
  "block.base_fee_per_gas": "每 Gas 基礎費用",
  "block.base_fee_per_gas_hint":
    "每單位 Gas 所需的最低費用。費用根據網路擁堵情況進行調整",
  "block.burnt_fees_hint":
    "區塊中包含的交易所銷毀的 {symbol} 數量。等於區塊每 Gas 基礎費用 * 已用 Gas",
  "block.burnt_fees_utilization_hint": "銷毀費用 / 交易手續費 * 100%",
  "block.priority_fee": "優先費 / 小費",
  "block.priority_fee_hint":
    "發送給驗證者以獲得交易優先級/包含的用戶自定義小費",
  "block.difficulty_hint": "{validatorTitle} 的區塊難度，用於校準區塊生成時間",
  "block.total_difficulty_hint": "截至此區塊的鏈總難度",
  "block.hash_hint": "區塊的 SHA256 哈希值",
  "block.parent_hash_hint": "生成此區塊的區塊哈希值",
  "block.nonce_hint": "區塊隨機數是邁向工作量證明時用來證明區塊工作量的值",
  "block.send_count": "發送次數",
  "block.send_count_hint": "截至此區塊的 L2 到 L1 交易累計數量",
  "block.send_root": "發送根",
  "block.send_root_hint":
    "代表截至此區塊的所有 L2 到 L1 交易的 Merkle 累加器根",
  "block.delayed_messages": "延遲消息",
  "block.delayed_messages_hint": "截至此區塊讀取的延遲 L1 到 L2 消息數",
  "block.tx_count_label": "{count} 筆交易",
  "block.blob_tx_count_label": "{count} 筆 blob 交易",
  "block.including": "，其中包括",
  "block.in_this_block": "（在此區塊中）",
  "block.height_hint": "特定區塊的區塊高度定義為區塊鏈中排在它前面的區塊數量",
  "block.size_hint": "區塊的位元組大小",
  "block.timestamp_hint": "區塊產生的日期和時間。",
  "block.transactions_hint": "區塊中包含的交易數量",
  "block.withdrawals_hint": "區塊中包含的信標鏈提現數量",
  "block.difficulty": "難度",
  "block.total_difficulty": "總難度",
  "block.hash": "哈希",
  "block.parent_hash": "父哈希",
  "tx.state.description":
    "當網路上發生交易時，代表當前狀態的一組信息將隨之更新。以下是這些變化的摘要。",
  "tx.state.empty": "該交易暫無狀態變更記錄。",
  "tx.state.before_change": "變更前",
  "tx.state.after_change": "變更後",
  "tx.state.change_amount": "變更量",
  "tx.state.mint_address": "鑄造地址",
  "tx.state.burn_address": "銷毀地址",
  "tx.state.miner_tooltip": "成功將區塊包含進入區塊鏈的區塊生產者",
  "tx.state.mint_burn_tooltip": "用於代幣鑄造和銷毀操作的地址",
  "tx.raw_trace.empty": "未找到追蹤條目。",
  "tx.logs.empty": "該交易暫無日誌記錄。",
  "tx.blobs.empty": "該交易暫無 Blob 資料。",
  "tx.blobs.blob_hash": "Blob 哈希",
  "tx.blobs.data_type": "數據類型",
  "tx.internals.empty": "該交易暫無內部交易記錄。",
  "tx.internals.gas_limit": "Gas 限制",
  "tx.internal.type.call": "調用",
  "tx.internal.type.delegatecall": "委託調用",
  "tx.internal.type.staticcall": "靜態調用",
  "tx.internal.type.create": "建立",
  "tx.internal.type.create2": "Create2",
  "tx.internal.type.selfdestruct": "自毀",
  "tx.internal.type.reward": "獎勵",
  "tx.token_transfers.empty": "該交易暫無代幣轉帳記錄。",
  "tx.token_transfers.empty_filtered": "未找到符合條件的代幣轉帳記錄。",
  "tx.type.contract_call": "合約調用",
  "tx.type.blob_transaction": "Blob 交易",
  "tx.type.token_transfer": "代幣轉帳",
  "tx.type.token_creation": "代幣建立",
  "tx.type.rootstock_remasc": "REMASC",
  "tx.type.rootstock_bridge": "跨鏈橋",
  "tx.type.transaction": "交易",
  "tx.asset_flows.wallet": "錢包",
  "tx.asset_flows.actions": "操作",
  "tx.asset_flows.empty": "該交易暫無轉帳記錄。",
  "tx.authorizations.empty": "該交易暫無授權記錄。",
  "tx.authorizations.authority": "授權方",
  "tx.authorizations.chain": "鏈",
  "tx.authorizations.chain_this": "本鏈",
  "tx.authorizations.chain_any": "任意鏈",
  "common.additional_info": "附加資訊",
  "common.txn_type": "交易類型",
  "common.more_details": "更多詳情",
  "tx.hint.transaction_hash": "分配給每個已驗證交易的唯一字元序列（交易 ID/TxID）",
  "tx.hint.status": "目前交易狀態：成功、失敗（錯誤）或掛起（處理中）",
  "tx.hint.status_details": "交易的詳細狀態進度",
  "tx.hint.l1_status": "交易確認到 L1 的路徑狀態",
  "tx.hint.revert_reason": "交易的回退原因",
  "tx.hint.batch_lifecycle": "狀態是批次生命週期的簡短說明",
  "tx.hint.block": "包含該交易的區塊號",
  "tx.hint.batch_index": "此交易的批次索引",
  "tx.hint.batch_number": "批次號",
  "tx.hint.batch_index_in_block": "包含此交易的批次索引",
  "tx.hint.timestamp": "包含該交易的日期和時間，以及確認所需的時間長度",
  "tx.hint.confidential_node": "執行機密計算的節點",
  "tx.hint.from": "發送交易的地址（外部地址或合約）",
  "tx.hint.to": "接收交易的地址（外部地址或合約）",
  "tx.hint.interop_target": "執行此跨鏈交易的目标地址",
  "tx.hint.commitment_tx": "包含此批次承諾的 L1 交易",
  "tx.hint.confirmation_tx": "包含此批次確認 of L1 交易",
  "tx.hint.value": "以原生代幣發送的價值（及相應的美元價值，如果適用）",
  "tx.hint.fee": "總交易費用",
  "tx.hint.fee_without_blob": "不包含 Blob 費用的交易費用",
  "tx.hint.poster_fee": "為 L1 資源支付給提交者的費用",
  "tx.hint.execution_fee": "為 L2 資源支付給網絡的費用",
  "tx.hint.gas_used": "交易實際使用的 Gas 量",
  "tx.hint.l1_data_gas": "預留用於 L1 資料費用的 L2 Gas",
  "tx.hint.l2_gas_used": "在 L2 資源上消耗 the L2 Gas",
  "tx.hint.l1_gas_used": "在 L1 上使用的總 Gas",
  "tx.hint.l1_gas_used_by_txn": "交易使用的 L1 Gas",
  "tx.hint.l1_gas_price": "L1 Gas 價格",
  "tx.hint.l1_data_fee": "L1 資料費，用於支付來自批次提交機制的 L1「安全」成本。結合 L2 執行費，L1 費用構成了交易支付的總費用。",
  "tx.hint.l1_fee_scalar": "動態開銷（費用係數）溢價，作為 L1 價格快速上漲時的緩衝。",
  "tx.hint.gas_fees_breakdown": "基礎費用是指區塊發布時網絡的 Base Fee，而最大費用和最大優先級費用分別是指用戶願意為其交易支付的最大金額以及給予 {validatorTitle} 的最大金額",
  "tx.hint.blob_fee": "此交易的 Blob 費用",
  "tx.hint.blob_gas_used": "此交易中 Blob 使用的 Gas 量",
  "tx.hint.blob_eth_used": "此交易中用於 Blob 的 {symbol} 數量",
  "tx.hint.input_data": "交易中包含的二進位資料。有關附加資訊，請參見日誌索引標籤",
  "tx.hint.gas_limit": "交易可使用最大 Gas 量",
  "block.merged_mining.bitcoin_header": "比特幣合併挖礦區塊頭",
  "block.merged_mining.coinbase_txn": "比特幣合併挖礦Coinbase交易",
  "block.merged_mining.merkle_proof": "比特幣合併挖礦默克爾證明",
  "block.merged_mining.rootstock_hash": "合併挖礦哈希",
  "block.celo_base_fee.handler_label": "基礎費用處理器",
  "block.celo_base_fee.handler_hint": "接收基礎費用的合約，負責處理費用使用。該合約由治理程序控制。",
  "block.celo_base_fee.total_label": "基礎費用總計",
  "block.celo_base_fee.total_hint_prefix": "FeeHandler定期銷毀80%的代幣。非CELO代幣會事先兌換為CELO。其餘的20%將發送到",
  "block.celo_base_fee.total_hint_suffix": "。",
  "block.celo_base_fee.burnt": "已銷毀",
  "block.celo_base_fee.percentage_of_amount": "金額的 {percentage}%",
  "block.blob_info.price_label": "Blob Gas 價格",
  "block.blob_info.price_hint": "用於Blob部署的每單位Gas的價格。Blob Gas獨立於普通Gas。兩種Gas價格都可能影響交易執行的優先級。",
  "block.blob_info.used_label": "已使用的 Blob Gas",
  "block.blob_info.used_hint": "本區塊中Blob實際使用的Gas量",
  "block.blob_info.burnt_label": "Blob銷毀費用",
  "block.blob_info.burnt_hint": "本區塊中用於Blob的 {symbol} 數量",
  "block.blob_info.utilization_tooltip": "Blob銷毀費用 / 交易費用 * 100%",
  "block.blob_info.excess_label": "多餘的 Blob Gas",
  "block.blob_info.excess_hint": "在本區塊之前，消耗的超過目標的Blob Gas的累計總量。",
  "block.zilliqa_qc.consensus_explanation": "提出區塊的共識輪次的迭代：",
  "block.zilliqa_qc.view_explanation": "View — 法定人數證書的視圖編號，指示共識輪次。",
  "block.zilliqa_qc.signature_explanation": "Signature — 代表驗證者協議的聚合BLS簽名。",
  "block.zilliqa_qc.signers_explanation": "Signers — 代表參與法定人數的驗證者索引的整數陣列（由聯合簽名的位向量指示）。",
  "block.zilliqa_qc.proposed_explanation": "Proposed by validator — 提出嵌套法定人數證書的驗點索引。",
  "block.zilliqa_qc.aggregate_quorum_certificate": "聚合法定人數證書",
  "block.zilliqa_qc.quorum_certificate": "法定人數證書",
  "block.zilliqa_qc.view": "視圖",
  "block.zilliqa_qc.signature": "簽名",
  "block.zilliqa_qc.signers": "簽名者",
  "block.zilliqa_qc.nested_quorum_certificates": "嵌套法定人數證書",
  "block.zilliqa_qc.proposed_by_validator": "驗證者提議",
  "tx.allowed_peekers.label": "允許的查看器",
  "tx.allowed_peekers.hint": "允許與機密數據進行交互的智能合約",
  "tx.scroll_fees.l1_fee_hint": "用於支付Rollup成本的L1費用",
  "tx.scroll_fees.l2_fee_hint": "L2執行費",
  "tx.scroll_fees.scalar_hint": "提交係數",
  "tx.scroll_fees.overhead_hint": "數據提交交易的額外Gas開銷",
  "tx.scroll_fees.l1_gas_fees_hint": "L1 Gas費用",
  "tx.scroll_fees.l1_blob_fees_hint": "L1 Blob費用",
  "tx.fee_per_gas.hint": "每單位Gas的費用",
  "tx.interop.source_txn_hint": "在源鏈上發起跨L2消息的原始交易",
  "tx.interop.relay_txn_hint": "將跨L2消息轉發到目標鏈的交易",
  "tx.withdrawal_status_arbitrum.status_hint": "交易的詳細狀態進度",
  "tx.withdrawal_status_arbitrum.origin_txn_hint": "從基礎層發起消息的交易的哈希",
  "tx.gas_price.hint": "發送方指定的每單位Gas的價格。在網路使用率高時，較高的Gas價格可以優先處理交易。",
  "tx.other.hint": "與此交易相關的其他數據",
  "blob.info.not_indexed": "此Blob尚未被索引",
  "blob.info.proof_label": "證明",
  "blob.info.proof_hint": "零知識證明，允許快速驗證承諾",
  "blob.info.commitment_label": "承諾",
  "blob.info.commitment_hint": "對Blob中數據的承諾",
  "blob.info.size_label": "大小，字節",
  "blob.info.size_hint": "Blob的字節大小",
  "blob.info.txn_hash_label": "交易哈希",
  "blob.info.txn_hash_hint": "包含此Blob的交易哈希",
  "blob.data.not_an_image": "不是圖像",
  "blob.data.title": "Blob 資料",
  "blob.data.select_type": "選擇類型",
  "blob.data.download": "下載",
  "blob.data.format.image": "圖像",
  "blob.data.format.raw": "原始資料",
  "blob.data.format.utf8": "UTF-8",
  "blob.data.format.base64": "Base64",
  "common.originating_l1_txn_hash": "發起 L1 交易哈希",
  "tx.hint.decoded_input_data": "已解碼的輸入資料",
  "tx.hint.method": "交易方法名稱",
  "stats.chart.incomplete_resolution": "未完成的{resolution}",
  "stats.tooltip.date": "日期",
  "stats.tooltip.dates": "日期範圍",
  "stats.tooltip.month": "月份",
  "stats.tooltip.year": "年份",
  "stats.tooltip.value": "數值",
  "stats.counter.averageBlockTime.title": "平均出塊時間",
  "stats.counter.averageBlockTime.description": "區塊納入區塊鏈所需的平均時間（秒）",
  "stats.counter.completedTxns.title": "已完成交易",
  "stats.counter.completedTxns.description": "成功狀態的交易數量",
  "stats.counter.lastNewContracts.title": "今日新增合約",
  "stats.counter.lastNewContracts.description": "今日（UTC）部署的合約數量",
  "stats.counter.lastNewVerifiedContracts.title": "今日已驗證合約",
  "stats.counter.lastNewVerifiedContracts.description": "今日（UTC）驗證的合約數量",
  "stats.counter.totalAccounts.title": "總帳戶數",
  "stats.counter.totalAccounts.description": "至少發送過 1 筆交易的外部帳戶（EOA）數量",
  "stats.counter.totalAddresses.title": "總地址數",
  "stats.counter.totalAddresses.description": "參與鏈上活動的地址數量",
  "stats.counter.totalBlocks.title": "總區塊數",
  "stats.counter.totalBlocks.description": "全時段區塊數量",
  "stats.counter.totalContracts.title": "總合約數",
  "stats.counter.totalContracts.description": "合約數量",
  "stats.counter.totalNativeCoinTransfers.title": "總 ETH 轉帳",
  "stats.counter.totalNativeCoinTransfers.description": "包含 ETH 轉帳的交易數量",
  "stats.counter.totalTokens.title": "總代幣數",
  "stats.counter.totalTokens.description": "所有代幣合約數量",
  "stats.counter.totalTxns.title": "總交易數",
  "stats.counter.totalTxns.description": "包括待處理、丟棄、替換、失敗在內的全部交易",
  "stats.counter.totalVerifiedContracts.title": "總已驗證合約",
  "stats.counter.totalVerifiedContracts.description": "已驗證合約數量",
  "stats.counter.newTxns24h.title": "24 小時交易數",
  "stats.counter.newTxns24h.description": "過去 24 小時內的新交易數量",
  "stats.counter.pendingTxns30m.title": "30 分鐘內待處理交易",
  "stats.counter.pendingTxns30m.description": "過去 30 分鐘內等待網路處理的交易",
  "stats.counter.txnsFee24h.title": "24 小時交易費",
  "stats.counter.txnsFee24h.description": "過去 24 小時內消耗的 ETH gas 費用總和",
  "stats.counter.averageTxnFee24h.title": "24 小時平均交易費",
  "stats.counter.averageTxnFee24h.description": "過去 24 小時內每筆交易平均消耗的 ETH gas 費用",
  "stats.section.accounts.title": "帳戶",
  "stats.section.transactions.title": "交易",
  "stats.section.blocks.title": "區塊",
  "stats.section.tokens.title": "代幣",
  "stats.section.gas.title": "Gas",
  "stats.section.contracts.title": "合約",
  "stats.section.user_ops.title": "使用者操作",
  "stats.chart.accountsGrowth.title": "帳戶數量",
  "stats.chart.accountsGrowth.description": "帳戶累計成長趨勢",
  "stats.chart.activeAccounts.title": "活躍帳戶",
  "stats.chart.activeAccounts.description": "各週期活躍帳戶數量",
  "stats.chart.newAccounts.title": "新增帳戶",
  "stats.chart.newAccounts.description": "新增加的帳戶數量",
  "stats.chart.averageTxnFee.title": "平均交易費",
  "stats.chart.averageTxnFee.description": "每筆交易平均消耗的 ETH gas 費用",
  "stats.chart.newTxns.title": "新增交易",
  "stats.chart.newTxns.description": "新增交易數量",
  "stats.chart.txnsFee.title": "交易費",
  "stats.chart.txnsFee.description": "消耗的 ETH gas 費用總和",
  "stats.chart.txnsGrowth.title": "交易數量",
  "stats.chart.txnsGrowth.description": "交易累計成長趨勢",
  "stats.chart.txnsSuccessRate.title": "交易成功率",
  "stats.chart.txnsSuccessRate.description": "所有已包含交易的成功率",
  "stats.chart.averageBlockRewards.title": "平均區塊獎勵",
  "stats.chart.averageBlockRewards.description": "平均獎勵數量",
  "stats.chart.averageBlockSize.title": "平均區塊大小",
  "stats.chart.averageBlockSize.description": "區塊各欄位佔用的空間（位元組）",
  "stats.chart.newBlocks.title": "新增區塊",
  "stats.chart.newBlocks.description": "鏈上新增區塊數量",
  "stats.chart.newNativeCoinTransfers.title": "ETH 轉帳數量",
  "stats.chart.newNativeCoinTransfers.description": "已完成的代幣轉帳",
  "stats.chart.averageGasLimit.title": "平均 Gas 上限",
  "stats.chart.averageGasLimit.description": "平均區塊 Gas 上限",
  "stats.chart.averageGasPrice.title": "平均 Gas 價格",
  "stats.chart.averageGasPrice.description": "每單位 Gas 的平均價格（Gwei）",
  "stats.chart.gasUsedGrowth.title": "Gas 總用量",
  "stats.chart.gasUsedGrowth.description": "Gas 累計使用量",
  "stats.chart.networkUtilization.title": "網路利用率",
  "stats.chart.networkUtilization.description": "Gas 使用量占 Gas 上限的百分比",
  "stats.chart.averageGasUsed.title": "平均 Gas 用量",
  "stats.chart.averageGasUsed.description": "每個區塊平均使用的 Gas 數量",
  "stats.chart.contractsGrowth.title": "合約數量",
  "stats.chart.contractsGrowth.description": "合約累計成長趨勢",
  "stats.chart.newContracts.title": "新增合約",
  "stats.chart.newContracts.description": "網路中新增合約數量",
  "stats.chart.newVerifiedContracts.title": "新增已驗證合約",
  "stats.chart.newVerifiedContracts.description": "新驗證的合約數量",
  "stats.chart.verifiedContractsGrowth.title": "已驗證合約數量",
  "stats.chart.verifiedContractsGrowth.description": "已驗證合約累計成長趨勢",
};

export const translations: Record<Locale, Record<TranslationKey, string>> = {
  en,
  "zh-CN": zhCN,
  "zh-TW": zhTW,
};
